<template>
  <div id="relationships_page" class="mx-28 my-32">
    <div class="flex">
      <el-select
        v-model="selectTeam"
        filterable
        placeholder="Select"
        class="input-style"
        :class="[ blurMode ?  'blurelement': '' ]"
      >
        <el-option
          v-if="user.user_type !== 'leadership'"
          class="text-dropdown"
          :label="`All Teams (${optionsTeam.length})`"
          :value="`All Teams (${optionsTeam.length})`"
        ></el-option>
        <el-option
          class="text-dropdown"
          :class="[ blurMode ?  'blurelement': '' ]"
          v-for="item in optionsTeam"
          :key="item.key"
          :label="item.name"
          :value="item.key"
        ></el-option>
      </el-select>
    </div>
    <div>
      <div class="fs-18 fw-700 mt-32 flex-between">
        <span>Organizational Network</span>
        <el-tag
          v-if="focusedEmail"
          type="info"
          size="small"
          closable
          @close="clearFocusInMap"
          class="focus-tag"
        >
          Focusing: {{ focusedPersonName }}
        </el-tag>
      </div>
      <div class="fs-13 fc-747474 mt-6">
        Visualizing connections formed through peer/manager recognition, feedback exchanges, 
        and meaningful interactions over the past 6 months
      </div>
    </div>
    <div class="flex-center mt-16">
      <div class="label-input">Nodes</div>
      <div class="showOption showOption-40">
        <el-menu
          class="el-menu-demo menuOptionStyle"
          mode="horizontal"

          style="width: 210px"
        >
          <el-submenu index="0" style="width: 210px">
            <template slot="title">
              <span class="txtOption2">{{ profileSelectedName }}</span>
            </template>
            <template v-if="!blurMode">
              <el-menu-item
                v-for="(value, index) in profileNodesListFilter"
                :key="value + index"
                @click="profileSetting(value)"
                class="is-active"
                style="font-size: 16px; width: 210px"
                >{{ value.name }}
                </el-menu-item>
              <!-- {{ profileSetting(profileNodesList[0]) }} -->
            </template>
            <template v-else>
              <!-- {{ profileSetting(profileNodesList[4]) }} -->
            </template>
          </el-submenu>
        </el-menu>
      </div>
      <div class="label-input">Attribute</div>
      <div class="showOption showOption-40">
        <el-menu
          class="el-menu-demo menuOptionStyle"
          mode="horizontal"
          style="width: 210px"
        >
          <el-submenu index="0" style="width: 210px">
            <template slot="title">
              <span class="txtOption2">{{ attributeName }}</span>
            </template>
            <el-menu-item
              v-for="(value, index) in attributeList"
              :key="value + index"
              @click="attributeSetting(value)"
              class="is-active"
              style="font-size: 16px; width: 210px"
              >{{ value.name }}</el-menu-item
            >
          </el-submenu>
        </el-menu>
      </div>
      <div class="label-input">Links</div>
      <div class="showOption showOption-40">
        <el-menu
          class="el-menu-demo menuOptionStyle"
          mode="horizontal"
          style="width: 210px"
        >
          <el-submenu index="0" style="width: 210px">
            <template slot="title">
              <span class="txtOption2">{{ linksName }}</span>
            </template>
            <el-menu-item
              v-for="(value, index) in linkList"
              :key="value + index"
              @click="linksSetting(value)"
              class="is-active"
              style="font-size: 16px; width: 210px"
              >{{ value.name }}</el-menu-item
            >
          </el-submenu>
        </el-menu>
      </div>
    </div>
    <div class="mt-24 relative" style="height: 420px">
      <iframe
        v-if="iframeLinkCached"
        ref="iframeRef"
        id="iframeRef"
        :src="iframeLinkCached"
        class="thin-scrollbar iframe-container"
        :style="{ height: '100%', width: '100%' }"
        allow="fullscreen"
      ></iframe>
      <div
        @click="openFullscreen"
        class="absolute-btn-iframe flex-mid"
        style="bottom: 16px; right: 16px"
      >
        <img
          :src="$utils('icons', 'fullscreen_24dp')"
          alt="icons_fullscreen_24dp"
        />
      </div>
    </div>
    <div style="margin-top: 42px">
      <div class="flex-center">
        <div class="fs-18 fw-700">Relationship Attributes</div>
        <div class="flex-center" style="margin-left: 60px">
          <!-- Power Classification Filter -->
          <div class="mr-16">
            <el-dropdown
              trigger="click"
              :hide-on-click="false"
              ref="dropdownPowerMenu"
              placement="bottom-start"
            >
              <div class="text-drop-down flex-mid">
                <span v-if="powerClassificationCheck.length > 0">
                  ({{ powerClassificationCheck.length }})&nbsp;
                </span>
                <div>Relationship Power</div>
                <div class="arrow ml-8">
                  <i class="el-icon-arrow-down"></i>
                </div>
              </div>
              <el-dropdown-menu slot="dropdown">
                <div class="dropdownHeader">
                  <div>
                    <el-button
                      @click="handleSelectAllPowerTypes"
                      class="dropdownHeaderTextStyle"
                      type="text"
                      >{{ $t("powerUp.Select_all") }}</el-button
                    >
                    <el-button
                      @click="powerClassificationFilter = []"
                      class="dropdownHeaderTextStyle"
                      style="margin-left: 24px"
                      type="text"
                      >{{ $t("powerUp.Clear") }}</el-button
                    >
                  </div>
                  <el-tooltip effect="dark" placement="top">
                    <div class="tooltipStyle" slot="content">
                      Filter by power rating classification groups
                    </div>
                    <div class="flex-center">
                      <img
                        :src="$utils('icons', 'ic_help_outline-16px')"
                        alt="icons_ic_help_outline-16px"
                      />
                    </div>
                  </el-tooltip>
                </div>
                <div class="dropdownItem-tabActivity thin-scrollbar">
                  <el-checkbox-group v-model="powerClassificationFilter">
                    <el-dropdown-item
                      v-for="item in powerClassificationOptions"
                      :key="item.type"
                    >
                      <el-checkbox :label="item.type" :key="item.type">
                        <span class="flex-center">
                          <span :class="`power-indicator bg-${item.color}`"></span>
                          {{ item.type }}
                        </span>
                      </el-checkbox>
                    </el-dropdown-item>
                  </el-checkbox-group>
                </div>
                <div class="dropdownFooter">
                  <el-button @click="clearPowerFilterSelected" type="cancel">{{
                    $t("powerUp.Cancel")
                  }}</el-button>
                  <el-button @click="savePowerFilterSelected" type="save">{{
                    $t("powerUp.Okay")
                  }}</el-button>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          
          <!-- Signature Filter -->
          <div>
            <el-dropdown
              trigger="click"
              :hide-on-click="false"
              ref="dropdownValuesMenu"
              placement="bottom-start"
            >
              <!-- <img
                class="cursor-pointer"
                :src="$utils('icons', 'filter-list-24px')"
                alt="icons_filter-list-24px"
              /> -->
              <div class="text-drop-down flex-mid">
                <span v-if="arrDataCheck.length > 0">
                  ({{ arrDataCheck.length }})&nbsp;
                </span>
                <div>Signature</div>
                <div class="arrow ml-8">
                  <i class="el-icon-arrow-down"></i>
                </div>
              </div>
              <el-dropdown-menu slot="dropdown">
                <div class="dropdownHeader">
                  <div>
                    <el-button
                      @click="handleSelectAllValues"
                      class="dropdownHeaderTextStyle"
                      type="text"
                      >{{ $t("powerUp.Select_all") }}</el-button
                    >
                    <el-button
                      @click="signatureType = []"
                      class="dropdownHeaderTextStyle"
                      style="margin-left: 24px"
                      type="text"
                      >{{ $t("powerUp.Clear") }}</el-button
                    >
                  </div>
                  <el-tooltip effect="dark" placement="top">
                    <div class="tooltipStyle" slot="content">
                      Filter by the signature value tagged in the relationships
                    </div>
                    <div class="flex-center">
                      <img
                        :src="$utils('icons', 'ic_help_outline-16px')"
                        alt="icons_ic_help_outline-16px"
                      />
                    </div>
                  </el-tooltip>
                </div>
                <div class="dropdownItem-tabActivity thin-scrollbar">
                  <el-checkbox-group v-model="signatureType">
                    <el-dropdown-item
                      v-for="item in signatureOption"
                      :key="item.type"
                    >
                      <el-checkbox :label="item.type" :key="item.type">{{
                        item.type
                      }}</el-checkbox>
                    </el-dropdown-item>
                  </el-checkbox-group>
                </div>
                <div class="dropdownFooter">
                  <el-button @click="clearValueSelected" type="cancel">{{
                    $t("powerUp.Cancel")
                  }}</el-button>
                  <el-button @click="saveValueFiltered" type="save">{{
                    $t("powerUp.Okay")
                  }}</el-button>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <!-- <div class="fs-12 fw-700 mr-12 ml-38">Sort by</div>
          <div class="showOption showOption-40">
            <el-menu
              class="el-menu-demo menuOptionStyle"
              mode="horizontal"
              style="width: 210px"
            >
              <el-submenu :index="`${selectMainPageSort}`" style="width: 210px">
                <template slot="title">
                  <span class="txtOption2">{{
                    tableFiterList[selectMainPageSort].name
                  }}</span>
                </template>
                <el-menu-item
                  v-for="(value, index) in tableFiterList"
                  :key="value + index"
                  :index="`${index}`"
                  @click="selectTableFillter"
                  class="is-active"
                  style="font-size: 16px; width: 210px"
                  >{{ value.name }}</el-menu-item
                >
              </el-submenu>
            </el-menu>
          </div> -->
        </div>
      </div>
      
      <div class="flex-center table-heaer-category">
        <div class="mr-auto"></div>
        <!-- No header for Power + Name,Team columns (80px + 200px = 280px) -->
        <div style="width: 340px"></div>
        <!-- Connections: Total + Inner/Outer + Strong (75px + 100px + 80px = 255px) -->
        <div class="box flex-mid ml-12" style="width: 240px">Connections</div>
        <!-- Engagement: M/E Ratio (100px) -->
        <div class="box flex-mid ml-12" style="width: 100px">Engagement</div>
        <!-- Signatures: Types (230px) -->
        <div class="box flex-mid ml-12" style="width: 230px">Signatures</div>
      </div>
      <div>
        <div class="mt-16 relationship-table">
          <el-table
            :default-sort="{ prop: 'powerRating', order: 'descending' }"
            ref="multipleTable"
            :data="datalistWithPowerRating"
            style="width: 100%"
            :empty-text="` `"
            @sort-change="Sort"
          >
            <el-table-column
              width="80"
              sortable
              prop="powerRating"
              :render-header="renderPowerRatingHeader"
            >
              <template slot-scope="scope">
                <div class="power-rating-cell">
                  <div class="power-rating-score" :class="getPowerRatingClass(scope.row.powerRating)">
                    {{ scope.row.powerRating }}
                  </div>
                </div>
              </template>
            </el-table-column>
            
            <el-table-column
              width="240"
              sortable
              prop="fullName"
              label="Name, Team"
            >
              <template slot-scope="scope">
                <div class="flex-center">
                  <img
                    v-if="scope.row.profileImage"
                    v-lazy="scope.row.profileImage"
                    :key="scope.row.profileImage"
                    class="image-skeleton image-profile-42 flex-mid mr-12"
                    :class="[ blurMode ?  'blurelement': '' ]"
                  />
                  <div v-else class="image image-profile-42 flex-mid mr-12"
                  :class="[ blurMode ?  'blurelement': '' ]">
                    <div class="text-in-image text-in-image-42 flex-mid">
                      {{
                        $utils("acronymName", { fullName: scope.row.fullName })
                      }}
                    </div>
                  </div>
                  <div
                    class="fc-000000 ellipsis"
                    style="line-height: 16px; width: 206px"
                  >
                    <div class="fs-14 fw-700 ellipsis cursor-pointer name-with-focus"
                    :class="[ blurMode ?  'blurelement': '' ]"
                    @click="showPreviewData(scope.row)">
                      {{ scope.row.fullName }}
                      <i 
                        class="el-icon-view focus-icon-inline"
                        @click.stop="focusPersonInMap(scope.row)"
                        title="Focus in relationship map"
                      ></i>
                    </div>
                    <div class="fs-13 fw-700 opa-06 ellipsis"
                    :class="[ blurMode ?  'blurelement': '' ]">
                      {{ scope.row.teamName }}
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              width="75"
              sortable
              prop="total_count"
              :render-header="renderTotalConnectionsHeader"
            >
              <template slot-scope="scope">
                <div
                  v-if="scope.row.total_count > 0"
                  class="center value-line flex-mid pb-4"
                  @click="openConnectionsView('Total', scope.row)"
                >
                  {{ scope.row.total_count }}
                </div>
                <div v-else class="center value-no-line flex-mid pb-4">
                  {{ scope.row.total_count }}
                </div>
              </template>
            </el-table-column>

            <el-table-column
              width="100"
              :render-header="renderDistributionHeader"
            >
              <template slot-scope="scope">
                <div class="distribution-cell">
                  <div class="distribution-split-bar" v-if="scope.row.total_count > 0">
                    <div 
                      class="distribution-inner-segment"
                      :style="{ width: getInnerPercentage(scope.row) + '%' }"
                      :title="`${scope.row.inner_count} inner connections (${getInnerPercentage(scope.row)}%)`"
                    ></div>
                    <div 
                      class="distribution-outer-segment"
                      :style="{ width: (100 - getInnerPercentage(scope.row)) + '%' }"
                      :title="`${scope.row.outer_count} outer connections (${100 - getInnerPercentage(scope.row)}%)`"
                    ></div>
                  </div>
                  <div class="distribution-values">
                    <span 
                      class="inner-value"
                      :class="{ clickable: scope.row.inner_count > 0 }"
                      @click="scope.row.inner_count > 0 ? openConnectionsView('Inner', scope.row) : null"
                    >
                      {{ scope.row.inner_count }}
                    </span>
                    <span class="separator">/</span>
                    <span 
                      class="outer-value"
                      :class="{ clickable: scope.row.outer_count > 0 }"
                      @click="scope.row.outer_count > 0 ? openConnectionsView('Outer', scope.row) : null"
                    >
                      {{ scope.row.outer_count }}
                    </span>
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              width="80"
              sortable
              prop="strong_count"
              :render-header="renderStrongConnectionsHeader"
            >
              <template slot-scope="scope">
                <el-tooltip placement="top" :content="getStrongConnectionsTooltip(scope.row.strong_count)">
                  <div class="strong-connections-cell-minimal">
                    <div
                      class="strong-connections-badge"
                      v-bind:class="renderStrongConnectionsColor(scope.row.strong_count)"
                      @click="scope.row.strong_count > 0 ? openConnectionsView('Strong', scope.row) : null"
                    >
                      {{ scope.row.strong_count }}
                    </div>
                  </div>
                </el-tooltip>
              </template>
            </el-table-column>

            <el-table-column
              width="100"
              sortable
              prop="me_ratio"
              :render-header="renderMERatioHeader"
            >
              <template slot-scope="scope">
                <el-tooltip placement="top" :content="getMERatioTooltip(scope.row.me_ratio)">
                  <div class="me-ratio-cell-minimal">
                    <div class="me-ratio-badge" v-bind:class="renderME_Ratio_BGColor(scope.row.me_ratio)">
                      {{ scope.row.me_ratio >= 0 ? scope.row.me_ratio : "-" }}
                    </div>
                  </div>
                </el-tooltip>
              </template>
            </el-table-column>

            <el-table-column
              width="230"
              sortable
              prop="signatures_count"
              :render-header="renderSignaturesHeader"
            >
              <template slot-scope="scope">
                <div class="flex type-container">
                  <template v-if="!scope.row.signatures || scope.row.signatures.length <= 3">
                    <div
                      v-if="scope.row.signatures && scope.row.signatures.length"
                      v-for="(value, index) in scope.row.signatures"
                      :key="value.id + scope.row.email"
                      class="signature-item-wrapper"
                    >
                      <el-tooltip placement="top">
                        <div
                          slot="content"
                          class="fw-400 fs-12"
                          style="width: 220px"
                        >
                          {{ mappingSignatures(value.id, "tooltip") }}
                        </div>
                        <div :class="`type-box${value.color} flex-center signature-badge-${value.id.toLowerCase().replace(/\s+/g, '')}`">
                          <img
                            v-if="mappingSignatures(value.id, 'icon')"
                            :src="
                              $utils('icons', mappingSignatures(value.id, 'icon'))
                            "
                            class="icon"
                            alt="icons_sig_bridge"
                          />
                          <div v-else class="icon"></div>
                          <div class="label">{{ value.name }}</div>
                        </div>
                      </el-tooltip>
                    </div>
                    <div v-if="!scope.row.signatures || !scope.row.signatures.length" class="no-signatures">
                      No signatures available
                    </div>
                  </template>
                  <template v-else>
                    <div
                      v-for="(value, index) in getPrioritySignatures(scope.row.signatures || [], 3)"
                      :key="value.id + scope.row.email"
                      class="signature-item-wrapper"
                    >
                      <el-tooltip placement="top">
                        <div
                          slot="content"
                          class="fw-400 fs-12"
                          style="width: 220px"
                        >
                          {{ mappingSignatures(value.id, "tooltip") }}
                        </div>
                        <div :class="`type-box${value.color} flex-center signature-badge-${value.id.toLowerCase().replace(/\s+/g, '')}`">
                          <img
                            v-if="mappingSignatures(value.id, 'icon')"
                            :src="
                              $utils('icons', mappingSignatures(value.id, 'icon'))
                            "
                            class="icon"
                            alt="icons_sig_bridge"
                          />
                          <div v-else class="icon"></div>
                          <div class="label">{{ value.name }}</div>
                        </div>
                      </el-tooltip>
                    </div>
                    <el-popover
                      placement="bottom"
                      width="280"
                      trigger="click"
                      popper-class="signatures-popover"
                    >
                      <div class="signatures-popover-content">
                        <div class="signatures-popover-title">All Signatures ({{ (scope.row.signatures || []).length }})</div>
                        <div class="signatures-grid">
                          <div
                            v-for="value in getPrioritySignatures(scope.row.signatures || [], 99)"
                            :key="value.id + scope.row.email + '-popover'"
                            class="signature-item"
                          >
                            <div :class="`type-box${value.color} flex-center signature-badge-${value.id.toLowerCase().replace(/\s+/g, '')}`">
                              <img
                                v-if="mappingSignatures(value.id, 'icon')"
                                :src="
                                  $utils('icons', mappingSignatures(value.id, 'icon'))
                                "
                                class="icon"
                                alt="icons_sig_bridge"
                              />
                              <div v-else class="icon"></div>
                              <div class="label">{{ value.name }}</div>
                            </div>
                            <div class="signature-description">
                              {{ mappingSignatures(value.id, "tooltip") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div slot="reference" class="show-more-signatures">
                        +{{ (scope.row.signatures || []).length - 3 }} more
                      </div>
                    </el-popover>
                  </template>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div
            v-if="loadingRaltionshipTable"
            class="center relative"
            style="margin-top: -60px; z-index: 99"
          >
            <div
              v-for="value in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
              :key="'mock_data_on_loading_' + value"
              class="flex-center loading-member-table opa-06"
              :style="`height: 54px; animation-duration: ${value * 1.5 + 1}s`"
            >
              <div class="flex-mid ml-10">
                <div class="image-skeleton image-profile-42 opa-06"></div>
              </div>
              <div class="pl-38" style="width: 174px">
                <div class="text-skeleton fs-14" style="width: 130px">
                  &nbsp;
                </div>
                <div
                  class="text-skeleton fs-14 opa-06 mt-6"
                  style="width: 120px"
                >
                  &nbsp;
                </div>
              </div>
              <div class="flex-mid" style="width: 80px">
                <div class="text-skeleton fs-14 mr-20" style="width: 20px">
                  &nbsp;
                </div>
              </div>
              <div class="flex-mid" style="width: 80px">
                <div class="text-skeleton fs-14 mr-20" style="width: 20px">
                  &nbsp;
                </div>
              </div>
              <div class="flex-mid" style="width: 75px">
                <div class="text-skeleton fs-14 mr-20" style="width: 20px">
                  &nbsp;
                </div>
              </div>
              <div class="flex-mid" style="width: 75px">
                <div class="text-skeleton fs-14 mr-20" style="width: 20px">
                  &nbsp;
                </div>
              </div>
              <div class="flex-mid" style="width: 130px">
                <div
                  class="text-skeleton fs-20 mr-20"
                  style="width: 32px; border-radius: 20px"
                >
                  &nbsp;
                </div>
              </div>
              <div class="flex-mid" style="width: 160px">
                <div class="text-skeleton fs-22 mr-8" style="width: 100px">
                  &nbsp;
                </div>
                <div
                  class="text-skeleton fs-22 mr-auto"
                  style="width: 40px; border-radius: 4px"
                >
                  &nbsp;
                </div>
              </div>
            </div>
          </div>
          <div
            v-else
            class="flex-center pagination mt-10 relative"
            style="z-index: 99"
          >
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="page"
              :page-size="10"
              :pager-count="5"
              layout="prev, pager, next"
              :total="datalistFiltered.length"
            ></el-pagination>
            <span class="results-status">
              {{ datalistWithPowerRating.length }}
              {{ $t("insights.results_from") }}
              {{ $utils("addCommasInNumber", datalistFiltered.length) }}
              {{ $t("insights.results") }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="remove-padding-modal">
      <el-dialog :visible.sync="connectionsViewModal" width="990px" top="8vh">
        <div class="p-32">
          <div>
            <div class="fs-18 fw-700 fc-00000" style="color: #000"
            :class="[ blurMode ?  'blurelement': '' ]">
              {{ modalData.name }}'s {{ modalData.type }} Connections
            </div>
          </div>
          <div class="flex-center table-heaer-category">
            <div class="mr-auto"></div>
            <!-- <div class="box flex-mid" style="width: 80px">Power</div> -->
            <div class="box flex-mid ml-12" style="width: 216px">Connections</div>
            <div class="box flex-mid ml-12" style="width: 100px">
              Engagement
            </div>
            <div class="box flex-mid ml-12" style="width: 255px">
              Signatures
            </div>
          </div>
          <div>
            <div class="mt-16 relationship-table">
              <el-table
                ref="multipleTable"
                :data="tableConnectionsDataWithPowerRating"
                style="width: 100%"
                mx-height="720"
                :empty-text="` `"
              >
                <el-table-column
                  width="80"
                  sortable
                  prop="powerRating"
                  :render-header="renderPowerRatingHeader"
                >
                  <template slot-scope="scope">
                    <div class="power-rating-cell">
                      <div class="power-rating-score" :class="getPowerRatingClass(scope.row.powerRating)">
                        {{ scope.row.powerRating }}
                      </div>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                  width="180"
                  sortable
                  prop="fullName"
                  label="Name, Team"
                >
                  <template slot-scope="scope">
                    <div class="flex-center">
                      <img
                        v-if="scope.row.profileImage"
                        v-lazy="scope.row.profileImage"
                        :key="scope.row.profileImage"
                        class="image-skeleton image-profile-42 flex-mid mr-12"
                        :class="[ blurMode ?  'blurelement': '' ]"
                      />
                      <div v-else class="image image-profile-42 flex-mid mr-12"
                      :class="[ blurMode ?  'blurelement': '' ]">
                        <div class="text-in-image text-in-image-42 flex-mid">
                          {{
                            $utils("acronymName", {
                              fullName: scope.row.fullName,
                            })
                          }}
                        </div>
                      </div>
                      <div
                        class="fc-000000 ellipsis"
                        style="line-height: 16px; width: 186px"
                      >
                        <div class="fs-14 fw-700 ellipsis cursor-pointer name-with-focus"
                        :class="[ blurMode ?  'blurelement': '' ]"
                        @click="showPreviewData(scope.row)">
                          {{ scope.row.fullName }}
                          <i 
                            class="el-icon-view focus-icon-inline"
                            @click.stop="focusPersonInMap(scope.row)"
                            title="Focus in relationship map"
                          ></i>
                        </div>
                        <div class="fs-13 fw-700 opa-06 ellipsis"
                        :class="[ blurMode ?  'blurelement': '' ]">
                          {{ scope.row.teamName }}
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                  width="75"
                  sortable
                  prop="total_count"
                  label="Total"
                >
                  <template slot-scope="scope">
                    <div
                      v-if="scope.row.total_count > 0"
                      class="center value-line flex-mid pb-4"
                      @click="openConnectionsView('Total', scope.row)"
                    >
                      {{ scope.row.total_count }}
                    </div>
                    <div v-else class="center value-no-line flex-mid pb-4">
                      {{ scope.row.total_count }}
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                  width="100"
                  :render-header="renderDistributionHeader"
                >
                  <template slot-scope="scope">
                    <div class="distribution-cell">
                      <div class="distribution-split-bar" v-if="scope.row.total_count > 0">
                        <div 
                          class="distribution-inner-segment"
                          :style="{ width: getInnerPercentage(scope.row) + '%' }"
                          :title="`${scope.row.inner_count} inner connections (${getInnerPercentage(scope.row)}%)`"
                        ></div>
                        <div 
                          class="distribution-outer-segment"
                          :style="{ width: (100 - getInnerPercentage(scope.row)) + '%' }"
                          :title="`${scope.row.outer_count} outer connections (${100 - getInnerPercentage(scope.row)}%)`"
                        ></div>
                      </div>
                      <div class="distribution-values">
                        <span 
                          class="inner-value"
                          :class="{ clickable: scope.row.inner_count > 0 }"
                          @click="scope.row.inner_count > 0 ? openConnectionsView('Inner', scope.row) : null"
                        >
                          {{ scope.row.inner_count }}
                        </span>
                        <span class="separator">/</span>
                        <span 
                          class="outer-value"
                          :class="{ clickable: scope.row.outer_count > 0 }"
                          @click="scope.row.outer_count > 0 ? openConnectionsView('Outer', scope.row) : null"
                        >
                          {{ scope.row.outer_count }}
                        </span>
                      </div>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                  width="80"
                  sortable
                  prop="strong_count"
                  :render-header="renderStrongConnectionsHeader"
                >
                  <template slot-scope="scope">
                    <el-tooltip placement="top" :content="getStrongConnectionsTooltip(scope.row.strong_count)">
                      <div class="strong-connections-cell">
                        <div
                          class="strong-connections-circle"
                          v-bind:class="renderStrongConnectionsColor(scope.row.strong_count)"
                          @click="scope.row.strong_count > 0 ? openConnectionsView('Strong', scope.row) : null"
                        >
                          {{ scope.row.strong_count }}
                        </div>
                      </div>
                    </el-tooltip>
                  </template>
                </el-table-column>

                <el-table-column
                  width="120"
                  sortable
                  prop="me_ratio"
                  :render-header="renderMERatioHeader"
                >
                  <template slot-scope="scope">
                    <div class="flex-mid">
                      <div
                        class="center flex-mid pb-4"
                        v-bind:class="renderME_Ratio_BGColor(scope.row.me_ratio)"
                      >
                        {{ scope.row.me_ratio >= 0 ? scope.row.me_ratio : "-" }}
                      </div>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                  width="230"
                  sortable
                  prop="signatures_count"
                  :render-header="renderSignaturesHeader"
                >
                  <template slot-scope="scope">
                    <div class="flex type-container">
                      <template v-if="!scope.row.signatures || scope.row.signatures.length <= 3">
                        <div
                          v-if="scope.row.signatures && scope.row.signatures.length"
                          v-for="value in scope.row.signatures"
                          :key="value.id + scope.row.email"
                        >
                          <el-tooltip placement="top">
                            <div
                              slot="content"
                              class="fw-400 fs-12"
                              style="width: 220px"
                            >
                              {{ mappingSignatures(value.id, "tooltip") }}
                            </div>
                            <div :class="`type-box${value.color} flex-center signature-badge-${value.id.toLowerCase().replace(/\s+/g, '')}`">
                              <img
                                v-if="mappingSignatures(value.id, 'icon')"
                                :src="
                                  $utils('icons', mappingSignatures(value.id, 'icon'))
                                "
                                class="icon"
                                alt="icons_sig_bridge"
                              />
                              <div v-else class="icon"></div>
                              <div class="label">{{ value.name }}</div>
                            </div>
                          </el-tooltip>
                        </div>
                        <div v-if="!scope.row.signatures || !scope.row.signatures.length" class="no-signatures">
                          No signatures available
                        </div>
                      </template>
                      <template v-else>
                        <div
                          v-for="value in getPrioritySignatures(scope.row.signatures || [], 3)"
                          :key="value.id + scope.row.email"
                        >
                          <el-tooltip placement="top">
                            <div
                              slot="content"
                              class="fw-400 fs-12"
                              style="width: 220px"
                            >
                              {{ mappingSignatures(value.id, "tooltip") }}
                            </div>
                            <div :class="`type-box${value.color} flex-center signature-badge-${value.id.toLowerCase().replace(/\s+/g, '')}`">
                              <img
                                v-if="mappingSignatures(value.id, 'icon')"
                                :src="
                                  $utils('icons', mappingSignatures(value.id, 'icon'))
                                "
                                class="icon"
                                alt="icons_sig_bridge"
                              />
                              <div v-else class="icon"></div>
                              <div class="label">{{ value.name }}</div>
                            </div>
                          </el-tooltip>
                        </div>
                        <el-popover
                          placement="bottom"
                          width="280"
                          trigger="click"
                          popper-class="signatures-popover"
                        >
                          <div class="signatures-popover-content">
                            <div class="signatures-popover-title">All Signatures ({{ (scope.row.signatures || []).length }})</div>
                            <div class="signatures-grid">
                              <div
                                v-for="value in getPrioritySignatures(scope.row.signatures || [], 99)"
                                :key="value.id + scope.row.email + '-popover'"
                                class="signature-item"
                              >
                                <div :class="`type-box${value.color} flex-center signature-badge-${value.id.toLowerCase().replace(/\s+/g, '')}`">
                                  <img
                                    v-if="mappingSignatures(value.id, 'icon')"
                                    :src="
                                      $utils('icons', mappingSignatures(value.id, 'icon'))
                                    "
                                    class="icon"
                                    alt="icons_sig_bridge"
                                  />
                                  <div v-else class="icon"></div>
                                  <div class="label">{{ value.name }}</div>
                                </div>
                                <div class="signature-description">
                                  {{ mappingSignatures(value.id, "tooltip") }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div slot="reference" class="show-more-signatures">
                            +{{ (scope.row.signatures || []).length - 3 }} more
                          </div>
                        </el-popover>
                      </template>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <div
                v-if="loadingConnectionsTable"
                class="center relative"
                style="margin-top: -60px; z-index: 99"
              >
                <div
                  v-for="value in [1, 2, 3, 4]"
                  :key="'mock_data_on_loading_' + value"
                  class="flex-center loading-member-table opa-06"
                  :style="`height: 54px; animation-duration: ${
                    value * 1.5 + 1
                  }s`"
                >
                  <div class="flex-mid ml-10">
                    <div class="image-skeleton image-profile-42 opa-06"></div>
                  </div>
                  <div class="pl-38" style="width: 174px">
                    <div class="text-skeleton fs-14" style="width: 130px">
                      &nbsp;
                    </div>
                    <div
                      class="text-skeleton fs-14 opa-06 mt-6"
                      style="width: 120px"
                    >
                      &nbsp;
                    </div>
                  </div>
                  <div class="flex-mid" style="width: 80px">
                    <div class="text-skeleton fs-14 mr-20" style="width: 20px">
                      &nbsp;
                    </div>
                  </div>
                  <div class="flex-mid" style="width: 80px">
                    <div class="text-skeleton fs-14 mr-20" style="width: 20px">
                      &nbsp;
                    </div>
                  </div>
                  <div class="flex-mid" style="width: 75px">
                    <div class="text-skeleton fs-14 mr-20" style="width: 20px">
                      &nbsp;
                    </div>
                  </div>
                  <div class="flex-mid" style="width: 75px">
                    <div class="text-skeleton fs-14 mr-20" style="width: 20px">
                      &nbsp;
                    </div>
                  </div>
                  <div class="flex-mid" style="width: 130px">
                    <div
                      class="text-skeleton fs-20 mr-20"
                      style="width: 32px; border-radius: 20px"
                    >
                      &nbsp;
                    </div>
                  </div>
                  <div class="flex-mid" style="width: 160px">
                    <div class="text-skeleton fs-22 mr-8" style="width: 100px">
                      &nbsp;
                    </div>
                    <div
                      class="text-skeleton fs-22 mr-auto"
                      style="width: 40px; border-radius: 4px"
                    >
                      &nbsp;
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
      <el-dialog 
        :visible.sync="relationShipsModal" 
        width="90vw" 
        top="6vh"
        :fullscreen="true"
        :show-close="false"
        custom-class="relationships-fullscreen-dialog"
        @open="handleFullscreenOpen"
        @close="handleFullscreenClose"
      >
        <div class="relative fullscreen-container">
          <iframe
            ref="fullscreenIframeRef"
            id="fullscreenIframeRef"
            :src="iframeLink + '&mode=fullscreen'"
            class="thin-scrollbar iframe-container fullscreen-iframe"
          ></iframe>
          <div
            @click="closeFullscreen"
            class="absolute-btn-iframe flex-mid"
          >
            <img
              :src="$utils('icons', 'close_fullscreen_24dp')"
              alt="icons_close_fullscreen_24dp"
            />
          </div>
        </div>
      </el-dialog>
    </div>

    <!-- User Profile Modal -->
    <modal-preview-user 
      v-if="modalPreviewDataStatus" 
      :modalMemberData="modalMemberData" 
      :userDetail="userDetail"
      :showingModal="modalPreviewDataStatus" 
      :passProfileToRelationship="passProfileToRelationship"
      @closed="closedModal">
    </modal-preview-user>
  </div>
</template>

<script>
import ModalPreviewUser from '@/components/even/modal/user-preview.vue'

export default {
  name: "relationships",
  components: {
    ModalPreviewUser
  },
  async created() {
    await this.initializeRelationshipsView();
  },
  watch: {
    selectTeam(value) {
      if (this.optionsTeam.length > 0) {
        this.scheduleIframeLinkUpdate();
        if (this.relationshipsReadyForTeamChanges && this.hasRelationshipAttributeData()) {
          this.refreshRelationshipTable(value);
        }
      }
    },
    // Ensure default team is set once options load
    optionsTeam(newTeams, oldTeams) {
      if (newTeams && newTeams.length > 0) {
        const current = this.$store.getters["relationships/selectTeam"];
        const allTeamsLabel = `All Teams (${newTeams.length})`;
        if (!current || current === '') {
          const teamValue = this.user.user_type === 'leadership' ? this.user.team : allTeamsLabel;
          this.$store.commit('relationships/setTeamId', { keyword: teamValue });
        } else if (/All Teams/i.test(current) && current !== allTeamsLabel) {
          // Keep the selected value in sync with changing team counts
          this.$store.commit('relationships/setTeamId', { keyword: allTeamsLabel });
        }
      }
    },
    profileSelected(value) {
      if (value) {
        this.$store.commit("relationships/setNodes", value);
      }
    },
    attribute(value) {
      if (value) {
        this.$store.commit("relationships/setAttribute", value);
      }
    },
    links(value) {
      if (value) {
        this.$store.commit("relationships/setLinks", value);
      }
    },
    iframeLink(link) {
      if (link) {
        if (!this.iframeLoaded) {
          this.iframeLoaded = true;
        }
        // Always update the cached link to ensure iframe src updates
        this.iframeLinkCached = link;
        // Store the current state when updating iframe
        this.currentIframeState = this.parseIframeParams(link);
        this.onLoadIframe(link);
      }
    },
    datalistAll(newVal) {
      if (Array.isArray(newVal)) {
        this.loadingRaltionshipTable = false;
      }
    },
    blurMode(newVal) {
      if (newVal) {
        this.profileSetting(this.profileNodesList[4]);
      } else {
        this.profileSetting(this.profileNodesList[0]);
      }
    }
  },
  data() {
    return {
      modalData: {
        name: "",
        type: "",
      },
      profileSelected: "initials",
      profileSelectedName: "Initials & Team",
      profileNodesList: [
        {
          name: "Initials & Team",
          value: "initials_team",
        },
        // {
        //   name: "Initials & Cohort ⚒",
        //   value: "initials_cohort",
        // },
        {
          name: "Initials",
          value: "initials",
        },
        {
          name: "Profile Photo",
          value: "profile_photo",
        },
        {
          name: "None",
          value: "none",
        },
        {
          name: "Blurred",
          value: "blurred",
        }
      ],
      attribute: "impact_rating",
      attributeName: "Impact Rating",
      attributeList: [
        {
          name: "Impact Rating",
          value: "impact_rating",
        },
        {
          name: "Happiness",
          value: "happiness",
        },
        {
          name: "Well-being",
          value: "well-being",
        },
        {
          name: "eNPS",
          value: "eNPS",
        },
        {
          name: "NPS",
          value: "NPS",
        },
        {
          name: "Culture Index",
          value: "culture_index",
        },
        {
          name: "Toxic Behaviors",
          value: "toxic_behaviors",
        },
      ],
      links: "All Relational Data",
      linksName: "All Relational Data",
      linkList: [
        {
          name: "All Relational Data",
          value: "all_relational_data",
        },
        {
          name: "Meaningful Interactions Only",
          value: "meaningful_interactions_only",
        },
        {
          name: "Line of Management Only",
          value: "line_of_management_only",
        }
        // {
        //   name: "Only Peer Recognition",
        //   value: "only_peer_recognition",
        // },
        // {
        //   name: "Only Manager Recognition",
        //   value: "only_manager_recognition",
        // },
        // {
        //   name: "Only Manager feedback",
        //   value: "only_manager_feedback",
        // },
      ],
      tableFiter: "",
      tableFiterName: "",
      tableFiterList: [
        {
          name: "Most Total Connections",
          value: "totalArrData",
        },{
          name: "Most Inner Connections",
          value: "innerArrData",
        },{
          name: "Most Outer Connections",
          value: "outerArrData",
        },
        {
          name: "Most Strong Connections",
          value: "strongArrData",
        },
      ],
      selectMainPageSort: 0,
      loadingRaltionshipTable: true,
      // tableRalationshipAttributesData: [],
      loadingConnectionsTable: false,
      tableConnectionsData: [],
      connectionsViewModal: false,
      relationShipsModal: false,
      signatureType: [],
      signatureOption: [
        { type: "Brokerage" },
        { type: "Cohesion" },
        { type: "Connectivity" },
        { type: "Collective" },
        { type: "Influence" },
        { type: "Reachability" },
        { type: "Ripple" },
        { type: "Hub" },
        { type: "Strategist" },
        { type: "Community Leader" },
        { type: "Linker" },
        { type: "Insular"},
        { type: "Peripheral" },
        { type: "Distant" }
      ],
      arrDataCheck: [],
      // Power classification filter
      powerClassificationFilter: [],
      powerClassificationOptions: [
        { type: "Top Influencers", min: 80, max: 100, color: "green" },
        { type: "Strong Networkers", min: 60, max: 79, color: "blue" },
        { type: "Developing Networks", min: 40, max: 59, color: "yellow" },
        { type: "At Risk", min: 0, max: 39, color: "red" }
      ],
      powerClassificationCheck: [],
      iframeLoaded: false,
      iframeLinkCached: "",
      currentIframeState: null,
      iframeSyncFrame: null,
      relationshipsReadyForTeamChanges: false,
      // User profile modal data
      modalPreviewDataStatus: false,
      userDetail: {},
    };
  },

  computed: {
    user() {
      return this.$store.getters["authen/user"];
    },
    datalistAll() {
      return this.$store.getters["relationships/datalistAll"];
    },
    datalist() {
      return this.$store.getters["relationships/datalist"];
    },
    datalistFiltered() {
      // Get the complete filtered dataset without pagination
      if (!this.datalistAll || this.datalistAll.length === 0) {
        return [];
      }
      
      // Use precomputed powerRating when available; fallback to local calculation
      const allDataWithRatings = this.datalistAll.map(row => (
        row && row.powerRating !== undefined
          ? row
          : { ...row, powerRating: this.calculatePowerRating(row) }
      ));
      
      // Apply power classification filter only; preserve store ordering
      let filteredData = [...allDataWithRatings];
      if (this.powerClassificationCheck.length > 0) {
        filteredData = filteredData.filter(row => {
          return this.powerClassificationCheck.some(selectedType => {
            const powerOption = this.powerClassificationOptions.find(opt => opt.type === selectedType);
            return powerOption && row.powerRating >= powerOption.min && row.powerRating <= powerOption.max;
          });
        });
      }
      
      return filteredData;
    },
    datalistWithPowerRating() {
      // Apply pagination to the filtered data
      const page = this.$store.state.relationships.page || 1;
      const size = this.$store.state.relationships.size_page || 10;
      const startRow = (page - 1) * size;
      const endRow = startRow + size;
      
      return this.datalistFiltered.slice(startRow, endRow);
    },
    tableConnectionsDataWithPowerRating() {
      return this.tableConnectionsData.map(row => (
        row && row.powerRating !== undefined
          ? row
          : { ...row, powerRating: this.calculatePowerRating(row) }
      ));
    },
    page() {
      return this.$store.getters["relationships/page"];
    },
    signatures() {
      return this.$store.getters["relationships/signatures"];
    },
    // loadingRelationshipsTabs() {
    //   return this.$store.getters["relationships/loadingRelationshipsTabs"];
    // },
    selectTeam: {
      get() {
        if (this.optionsTeam.length > 0) {
          return this.$store.getters["relationships/selectTeam"];
        }
      },
      set(value) {
        if (this.optionsTeam.length > 0) {
          this.$store.commit("relationships/setTeamId", { keyword: value });
        }
      },
    },
    optionsTeam() {
      const optionsTeam = this.$store.getters["team/teamsall"];
      // Don't commit to store in a computed property - this causes performance issues
      return optionsTeam;
    },
    iframeLink() {
      return this.$store.getters["relationships/iframeLink"];
    },
    shouldShowIframe() {
      return this.iframeLinkCached && !this.iframeError && !this.showLoadButton;
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
    focusedEmail() {
      // Use state directly since the store exposes selected_email
      return this.$store.state.relationships && this.$store.state.relationships.selected_email || '';
    },
    focusedPersonName() {
      if (!this.focusedEmail) return '';
      
      // Find the person's name from the current data
      const person = this.datalistWithPowerRating.find(p => p.email === this.focusedEmail);
      return person ? person.fullName : this.focusedEmail;
    },
    profileNodesListFilter() {
      return this.profileNodesList.filter((f) => f.value !== "blurred");
    },
    modalMemberData() {
      return this.$store.getters["people/modalMemberData"];
    },
    membersAll() {
      return this.$store.getters["people/membersall"] || {};
    },
    passProfileToRelationship() {
      // Profile data structure for relationship mapping component
      let passProfile = {
        firstname: this.userDetail.firstname || "",
        lastname: this.userDetail.lastname || "",
        teamColor: this.userDetail.house_color || "",
        house: this.userDetail.house || "",
        pic: this.userDetail.large_pic || false,
      };
      return passProfile;
    },
    powerScoreDistribution() {
      const currentVersion = this.datalistAll ? this.datalistAll.length : 0;
      if (this._cachedPowerDistribution && this._powerDistVersion === currentVersion) {
        return this._cachedPowerDistribution;
      }

      if (!this.datalistAll || this.datalistAll.length === 0) {
        const empty = { topInfluencers: 0, strongNetworkers: 0, developing: 0, atRisk: 0, total: 0, average: 0 };
        this._cachedPowerDistribution = empty;
        this._powerDistVersion = currentVersion;
        return empty;
      }

      // Fast single-pass count using precomputed rating when available
      let topInfluencers = 0;
      let strongNetworkers = 0;
      let developing = 0;
      let atRisk = 0;
      let sum = 0;
      const arr = this.datalistAll;
      for (let i = 0; i < arr.length; i++) {
        const row = arr[i];
        const rating = row && row.powerRating !== undefined ? row.powerRating : this.calculatePowerRating(row);
        sum += rating;
        if (rating >= 80) topInfluencers++;
        else if (rating >= 60) strongNetworkers++;
        else if (rating >= 40) developing++;
        else atRisk++;
      }
      const total = arr.length;
      const average = total > 0 ? Math.round(sum / total) : 0;
      const distribution = { topInfluencers, strongNetworkers, developing, atRisk, total, average };

      this._cachedPowerDistribution = distribution;
      this._powerDistVersion = currentVersion;
      return distribution;
    },
  },
  methods: {
    hasRelationshipAttributeData() {
      const dataAllAttribute = this.$store.state.relationships && this.$store.state.relationships.dataAllAttribute;
      return Array.isArray(dataAllAttribute) && dataAllAttribute.length > 0;
    },
    getAllTeamsLabel() {
      return `All Teams (${this.optionsTeam.length})`;
    },
    ensureDefaultTeamSelection() {
      if (!this.optionsTeam || this.optionsTeam.length === 0) {
        return;
      }

      const current = this.$store.getters["relationships/selectTeam"];
      const allTeamsLabel = this.getAllTeamsLabel();
      if (!current || current === "") {
        const teamValue = this.user.user_type === "leadership" ? this.user.team : allTeamsLabel;
        this.$store.commit("relationships/setTeamId", { keyword: teamValue });
        return;
      }

      if (this.user.user_type !== "leadership" && /All Teams/i.test(current) && current !== allTeamsLabel) {
        this.$store.commit("relationships/setTeamId", { keyword: allTeamsLabel });
      }
    },
    scheduleIframeLinkUpdate() {
      if (this.iframeSyncFrame) {
        cancelAnimationFrame(this.iframeSyncFrame);
      }

      this.iframeSyncFrame = requestAnimationFrame(() => {
        this.iframeSyncFrame = null;
        if (this.user.company) {
          this.$store.commit("relationships/setIframeLink", {
            team: this.$store.getters["relationships/selectTeam"] || "",
            company: this.user.company,
          });
        }
      });
    },
    async refreshRelationshipTable(teamId = this.$store.getters["relationships/selectTeam"] || "") {
      this.loadingRaltionshipTable = true;
      await this.$store.dispatch("relationships/getDataTable", teamId);
      if (!this.datalistAll || this.datalistAll.length === 0) {
        this.loadingRaltionshipTable = false;
      }
    },
    async initializeRelationshipsView() {
      this.relationshipsReadyForTeamChanges = false;
      this.loadingRaltionshipTable = true;

      try {
        const pending = [this.$store.dispatch("relationships/getOrganization")];
        if (!this.optionsTeam || this.optionsTeam.length === 0) {
          pending.push(this.$store.dispatch("team/getTeamsOptions", this.user));
        }

        await Promise.all(pending);
        this.ensureDefaultTeamSelection();
        this.scheduleIframeLinkUpdate();

        if (this.hasRelationshipAttributeData()) {
          await this.refreshRelationshipTable();
        } else {
          await this.$store.dispatch("relationships/getAttributeData", this.user);
          if (!this.datalistAll || this.datalistAll.length === 0) {
            this.loadingRaltionshipTable = false;
          }
        }
      } catch (error) {
        console.error("Error initializing relationships view:", error);
        this.loadingRaltionshipTable = false;
      } finally {
        this.relationshipsReadyForTeamChanges = true;
      }
    },
    
    reloadIframeDeferred() {
      // Check if this is a full company view
      const isFullCompanyView = !this.selectTeam || 
                               (this.selectTeam && this.selectTeam.includes && this.selectTeam.includes('All Teams')) || 
                               this.selectTeam === this.user.company;
      
      if (isFullCompanyView && this.datalistAll && this.datalistAll.length > 50) {
        // For large datasets, show manual load button
        this.showLoadButton = true;
        this.iframeLoaded = false;
      } else {
        // For smaller datasets, auto-load
        this.loadIframeManually();
      }
    },
    computePowerDistributionAsync() {
      // Compute power distribution asynchronously
      requestAnimationFrame(() => {
        if (!this.datalistAll || this.datalistAll.length === 0) {
          this._cachedPowerDistribution = { topInfluencers: 0, strongNetworkers: 0, developing: 0, atRisk: 0, total: 0 };
          return;
        }
        
        const powerRatings = this.datalistAll.map(row => this.calculatePowerRating(row));
        
        const distribution = {
          topInfluencers: powerRatings.filter(rating => rating >= 80).length,
          strongNetworkers: powerRatings.filter(rating => rating >= 60 && rating < 80).length,
          developing: powerRatings.filter(rating => rating >= 40 && rating < 60).length,
          atRisk: powerRatings.filter(rating => rating < 40).length,
          total: powerRatings.length,
          average: powerRatings.length > 0 ? Math.round(powerRatings.reduce((sum, rating) => sum + rating, 0) / powerRatings.length) : 0
        };
        
        this._cachedPowerDistribution = distribution;
        this.$forceUpdate();
      });
    },
    loadIframeManually() {
      // Hide the load button
      this.showLoadButton = false;
      
      // Reset error state
      this.iframeError = false;
      this.iframeRetryCount = 0;
      
      this.$nextTick(() => {
        const iframe = this.$refs.iframeRef;
        if (iframe && this.iframeLinkCached) {
          // Add cache buster to ensure fresh load
          const url = new URL(this.iframeLinkCached);
          url.searchParams.set('_t', Date.now().toString());
          iframe.src = url.toString();
        }
      });
    },
    parseIframeParams(url) {
      const params = new URL(url).searchParams;
      return {
        company: params.get("company"),
        team: params.get("team"),
        nodes: params.get("nodes"),
        attribute: params.get("attribute"),
        links: params.get("links")
      };
    },
    async onLoadIframe(url) {
      const params = new URL(url).searchParams;
      const data = {
        type: "updateParams",
        data: {
          company: params.get("company"),
          team: params.get("team"),
          nodes: params.get("nodes"),
          attribute: params.get("attribute"),
          links: params.get("links"),
          isFullscreen: this.relationShipsModal
        },
      };

      // Wait for iframe to be ready
      await this.$nextTick();
      const iframe = this.relationShipsModal ? this.$refs.fullscreenIframeRef : this.$refs.iframeRef;
      
      if (iframe && iframe.contentWindow) {
        try {
          iframe.contentWindow.postMessage(data, "*");
        } catch (error) {
          console.error("Error posting message to iframe:", error);
        }
      }
    },
    openConnectionsView(type, data) {
      this.modalData.name = data.fullName;
      this.modalData.type = type;

      this.tableConnectionsData = [];
      this.loadingConnectionsTable = true;

      this.connectionsViewModal = true;
      
      // Use nextTick instead of setTimeout for better performance
      this.$nextTick(() => {
        if (type == "Inner") {
          this.tableConnectionsData = data.innerArrData;
        } else if (type == "Outer") {
          this.tableConnectionsData = data.outerArrData;
        } else if (type == "Strong") {
          this.tableConnectionsData = data.strongArrData;
        } else if (type == "Total") {
          this.tableConnectionsData = data.totalArrData;
        }
        this.loadingConnectionsTable = false;
      });
    },
    handleCurrentChange(val) {
      // Just update the page, datalistWithPowerRating computed will handle the rest
      this.$store.commit("relationships/setPage", val);
    },
    Sort({ column, prop, order }) {
      if (order) {
        // Just update the sort fields in the store, datalistWithPowerRating computed will handle the rest
        this.$store.commit("relationships/setSortField", column.property);
        this.$store.commit("relationships/setSortOrder", order === 'ascending' ? 'asc' : 'desc');
      }
    },
    profileSetting(value) {
      this.profileSelected = value.value;
      this.profileSelectedName = value.name;
    },
    attributeSetting(value) {
      this.attribute = value.value;
      this.attributeName = value.name;
    },
    linksSetting(value) {
      this.links = value.value;
      this.linksName = value.name;
    },
    selectTableFillter(row) {
      this.selectMainPageSort = row.index;
      const order = row.index
      if (order == 0) {
        this.$store.dispatch("relationships/sort", ['total_count', 'descending']);
      }else if(order == 1){
        this.$store.dispatch("relationships/sort", ['inner_count', 'descending']);
      }else if(order == 2){
        this.$store.dispatch("relationships/sort", ['outer_count', 'descending']);
      }else if(order == 3){
        this.$store.dispatch("relationships/sort", ['strong_count', 'descending']);
      }
      this.handleCurrentChange(this.page);

      // console.log("selectTableFillter", value);
      // this.tableFiter = value.value;
      // this.tableFiterName = value.name;
    },
    renderME_Ratio_BGColor(value) {
      if (value >= 1.0) {
        return "green me-ratio";
      } else if (value >= 0.6 && value < 1.0) {
        return "yellow me-ratio";
      } else if (value >= 0 && value < 0.6) {
        return "red me-ratio";
      }
    },
    mappingSignatures(id, type) {
      const tooltipList = this.signatures;

      // mapping data with id
      const signatures = tooltipList.find(
        (item) => item.id.toLowerCase() === id.toLowerCase()
      );
      return signatures ? signatures[type] : "";
    },
    handleSelectAllValues() {
      if (this.signatureType.length !== this.signatureOption.length) {
        let checked = [];
        for (const i in this.signatureOption) {
          checked.push(this.signatureOption[i].type);
        }
        this.signatureType = checked;
      }
    },
    clearValueSelected() {
      this.signatureType = this.arrDataCheck;
      this.$refs.dropdownValuesMenu.visible = false;
      this.$store.dispatch("relationships/filter", this.signatureType);
    },
    saveValueFiltered() {
      this.arrDataCheck = this.signatureType;
      this.$refs.dropdownValuesMenu.visible = false;
      this.$store.dispatch("relationships/filter", this.signatureType);

      // this.$store.commit("activity/setFilter", true);
      // this.$store.commit("activity/setActivity", []);
      // this.$store.dispatch("activity/getdatafilter", {core_value:this.checkedTalentType,classification:this.checkedArrClassificationCheck,reward:this.checkedArrRewardTypeCheck});
    },
    
    // Power Classification Filter Methods
    handleSelectAllPowerTypes() {
      if (this.powerClassificationFilter.length !== this.powerClassificationOptions.length) {
        let checked = [];
        for (const i in this.powerClassificationOptions) {
          checked.push(this.powerClassificationOptions[i].type);
        }
        this.powerClassificationFilter = checked;
      }
    },
    clearPowerFilterSelected() {
      this.powerClassificationFilter = this.powerClassificationCheck;
      this.$refs.dropdownPowerMenu.visible = false;
      this.applyPowerClassificationFilter();
    },
    savePowerFilterSelected() {
      this.powerClassificationCheck = this.powerClassificationFilter;
      this.$refs.dropdownPowerMenu.visible = false;
      this.applyPowerClassificationFilter();
    },
    applyPowerClassificationFilter() {
      // Apply the power classification filter to the data
      this.loadingRaltionshipTable = true;
      
      // Reset to page 1 when applying filters
      this.$store.commit("relationships/setPage", 1);
      
      // Filter will be applied in the computed property
      this.$nextTick(() => {
        this.loadingRaltionshipTable = false;
      });
    },
    renderStrongConnectionsHeader(creatElement, { column, $index }) {
      return (
        <el-tooltip content="Top center" placement="top" effect="light">
          <div slot="content" style="max-width: 240px; padding: 12px;">
            <div class="fw-700 fs-13 mb-2">Strong Connections</div>
            <div class="fs-12 mb-3 opa-08">
              Number of strong connections based on high relationship weight (≥0.66).
            </div>
            <div class="fs-12">
              <div class="tooltip-legend-item">
                <span class="tooltip-color bg-green"></span>
                <div>
                  <strong>3+ connections</strong>
                  <div class="fs-11 opa-06">Healthy network with strong relationships</div>
                </div>
              </div>
              <div class="tooltip-legend-item">
                <span class="tooltip-color bg-yellow"></span>
                <div>
                  <strong>1-2 connections</strong>
                  <div class="fs-11 opa-06">Limited relationships, room for growth</div>
                </div>
              </div>
              <div class="tooltip-legend-item">
                <span class="tooltip-color bg-red"></span>
                <div>
                  <strong>0 connections</strong>
                  <div class="fs-11 opa-06">No strong connections, needs support</div>
                </div>
              </div>
            </div>
          </div>
          <span class="header-text-tooltip">Strong</span>
        </el-tooltip>
      );
    },
    renderStrongConnectionsColor(value) {
      if (value >= 3) {
        return "green";
      } else if (value > 0) {
        return "yellow";
      } else {
        return "red";
      }
    },
    getStrongConnectionsTooltip(value) {
      if (value >= 3) {
        return "Healthy network: " + value + " strong connections";
      } else if (value >= 1) {
        return "Building network: " + value + " strong connection" + (value === 1 ? "" : "s");
      } else {
        return "No strong connections";
      }
    },
    renderSignaturesHeader(creatElement, { column, $index }) {
      return (
        <el-tooltip content="Top center" placement="top" effect="light">
          <div slot="content" style="max-width: 240px; padding: 12px;">
            <div class="fw-700 fs-13 mb-2">Network Types</div>
            <div class="fs-12 opa-08">
              The types of connections formed through recognition, feedback, and meaningful interactions. These signatures represent distinct network patterns and roles within the organization.
            </div>
          </div>
          <span class="header-text-tooltip">Types</span>
        </el-tooltip>
      );
    },
    openFullscreen() {
      this.relationShipsModal = true;
    },
    handleFullscreenOpen() {
      // Store current state before entering fullscreen and ensure we have a valid URL
      if (this.iframeLinkCached) {
        this.currentIframeState = this.parseIframeParams(this.iframeLinkCached);
        
        // Update iframe with fullscreen mode
        this.onLoadIframe(this.iframeLinkCached + '&mode=fullscreen');
      }
      
      // Add keyboard listener for ESC key
      document.addEventListener('keydown', this.handleEscKey);
    },
    handleFullscreenClose() {
      // Remove keyboard listener
      document.removeEventListener('keydown', this.handleEscKey);
      
      // Reconstruct URL with stored state
      if (this.currentIframeState) {
        const params = new URLSearchParams();
        Object.entries(this.currentIframeState).forEach(([key, value]) => {
          if (value) params.append(key, value);
        });
        
        const baseUrl = this.iframeLinkCached.split('?')[0];
        const newUrl = `${baseUrl}?${params.toString()}`;
        
        // Update main iframe with preserved state
        this.onLoadIframe(newUrl);
      }
    },
    closeFullscreen() {
      this.relationShipsModal = false;
    },
    handleEscKey(event) {
      if (event.key === 'Escape') {
        this.closeFullscreen();
      }
    },
    getPrioritySignatures(signatures, limit) {
      // Handle null/undefined signatures
      if (!signatures || !Array.isArray(signatures)) {
        return [];
      }
      
      // Define priority order for signature types
      const priorityOrder = {
        "Hub": 1,
        "Influence": 2,
        "Connectivity": 3,
        "Collective": 4,
        "Brokerage": 5,
        "Strategist": 6,
        "Community Leader": 7,
        "Reachability": 8,
        "Cohesion": 9,
        "Ripple": 10,
        "Linker": 11,
        "Isolated": 12,
        "Insular": 13,
        "Peripheral": 14,
        "Distant": 15
      };
      
      // Sort signatures by priority
      const sortedSignatures = [...signatures].sort((a, b) => {
        const priorityA = priorityOrder[a.name] || 999;
        const priorityB = priorityOrder[b.name] || 999;
        return priorityA - priorityB;
      });
      
      // Return top signatures based on limit
      return sortedSignatures.slice(0, limit);
    },
    getMERatioClass(ratio) {
      if (ratio >= 1.0) {
        return 'healthy';
      } else if (ratio >= 0.6 && ratio < 1.0) {
        return 'moderate';
      } else if (ratio >= 0) {
        return 'concerning';
      }
      return 'undefined';
    },
    getMERatioLabel(ratio) {
      if (ratio >= 1.0) {
        return 'Healthy';
      } else if (ratio >= 0.6 && ratio < 1.0) {
        return 'Moderate';
      } else if (ratio >= 0) {
        return 'Concerning';
      }
      return 'N/A';
    },
    getMERatioTooltip(ratio) {
      if (ratio >= 1.0) {
        return `Healthy M/E ratio: ${ratio} - Manager has similar or stronger network`;
      } else if (ratio >= 0.6 && ratio < 1.0) {
        return `Moderate M/E ratio: ${ratio} - Manager has somewhat stronger network`;
      } else if (ratio >= 0) {
        return `Concerning M/E ratio: ${ratio} - Large gap between manager and employee networks`;
      }
      return 'M/E ratio not available';
    },
    getSignaturePriority(signatureName) {
      // Return priority level based on signature importance
      const highPriority = ["Hub", "Influence", "Connectivity", "Collective"];
      const mediumPriority = ["Brokerage", "Strategist", "Community Leader", "Reachability"];
      const lowPriority = ["Cohesion", "Ripple", "Linker"];
      
      if (highPriority.includes(signatureName)) return 'high';
      if (mediumPriority.includes(signatureName)) return 'medium';
      if (lowPriority.includes(signatureName)) return 'low';
      return 'neutral';
    },
    calculatePowerRating(row) {
      // Input validation to prevent errors
      if (!row || typeof row !== 'object') {
        return 0;
      }
      
      // Ensure numeric values have safe defaults
      const strongCount = Number(row.strong_count) || 0;
      const totalCount = Number(row.total_count) || 0;
      const meRatio = Number(row.me_ratio) || 0;
      
      // Advanced relationship power rating based on organizational psychology and social network theory
      let score = 0;
      
      // Factor 1: Strong Connection Quality (40% weight)
      // More connections are always better, but with diminishing returns
      let strongQualityScore = 0;
      if (strongCount === 0) {
        strongQualityScore = 0;
      } else if (strongCount >= 1 && strongCount <= 2) {
        strongQualityScore = 0.6; // Building phase
      } else if (strongCount >= 3 && strongCount <= 5) {
        strongQualityScore = 1; // Sweet spot
      } else if (strongCount >= 6 && strongCount <= 10) {
        strongQualityScore = 1; // Still excellent, no penalty
      } else {
        // Diminishing returns for very high numbers (logarithmic scaling)
        // 11+ connections: gradually approaches but never exceeds 1.0
        strongQualityScore = Math.min(1, 0.85 + (0.15 * Math.log(strongCount) / Math.log(20)));
      }
      score += strongQualityScore * 40;
      
      // Factor 2: Network Position Score (30% weight)
      // Based on network signatures indicating structural advantages
      let positionScore = 0;
      if (row.signatures && row.signatures.length > 0) {
        const signatureScores = {
          // Power signatures - key network positions
          'Hub': 1.0,
          'Influence': 1.0,
          'Brokerage': 1.0,
          'Strategist': 1.0,
          // Leadership signatures
          'Community Leader': 0.8,
          'Collective': 0.8,
          'Linker': 0.8,
          // Support signatures
          'Connectivity': 0.6,
          'Reachability': 0.6,
          'Ripple': 0.6,
          // Neutral signatures
          'Cohesion': 0.4,
          // Risk signatures (negative impact)
          'Insular': -0.5,
          'Peripheral': -0.5,
          'Distant': -0.5
        };
        
        // Take the highest positive signature or apply penalties
        let maxPositiveScore = 0;
        let totalPenalty = 0;
        
        row.signatures.forEach(sig => {
          const sigScore = signatureScores[sig.name] || 0;
          if (sigScore > 0) {
            maxPositiveScore = Math.max(maxPositiveScore, sigScore);
          } else {
            totalPenalty += sigScore;
          }
        });
        
        positionScore = Math.max(0, maxPositiveScore + totalPenalty);
      }
      score += positionScore * 30;
      
      // Factor 3: Connection Efficiency (15% weight)
      // Logarithmic scaling with diminishing returns after 30 connections
      let efficiencyScore = 0;
      if (totalCount > 0) {
        // Use logarithmic scaling to handle diminishing returns
        efficiencyScore = Math.min(1, Math.log(totalCount + 1) / Math.log(31));
      }
      score += efficiencyScore * 15;
      
      // Factor 4: Network Diversity (10% weight)
      // Score both bridging (outer) and bonding (inner) social capital separately
      let diversityScore = 0;
      if (totalCount > 0) {
        const innerCount = Number(row.inner_count) || 0;
        const outerCount = totalCount - innerCount;
        
        // Cross-functional reach (outer connections) - 60% of diversity score
        let bridgingScore = 0;
        if (outerCount >= 4) bridgingScore = 1;      // Excellent cross-functional reach
        else if (outerCount >= 2) bridgingScore = 0.8;  // Good reach
        else if (outerCount >= 1) bridgingScore = 0.5;  // Some reach
        else bridgingScore = 0;                          // No cross-functional connections
        
        // Team integration (inner connections) - 40% of diversity score  
        let bondingScore = 0;
        if (innerCount >= 5) bondingScore = 1;       // Excellent team integration
        else if (innerCount >= 3) bondingScore = 0.8;   // Good integration
        else if (innerCount >= 1) bondingScore = 0.5;   // Some integration
        else bondingScore = 0;                           // No team connections
        
        diversityScore = (bridgingScore * 0.6) + (bondingScore * 0.4);
      }
      score += diversityScore * 10;
      
      // Factor 5: Manager Support (5% weight)
      // Optimal M/E ratio is 0.8-1.2 (manager has similar network)
      let managerScore = 0;
      if (meRatio >= 0) {
        if (meRatio >= 0.8 && meRatio <= 1.2) {
          managerScore = 1;
        } else if (meRatio >= 0.5 && meRatio <= 1.5) {
          managerScore = 0.7;
        } else if (meRatio >= 0.2 && meRatio <= 2.0) {
          managerScore = 0.5; // Less penalty for moderate misalignment
        } else {
          managerScore = 0.3; // Minimum score, not zero
        }
      }
      score += managerScore * 5;
      
      // Apply scaling multiplier based on total connections to prevent inflation
      let scalingMultiplier = 1.0;
      if (totalCount < 5) {
        scalingMultiplier = 0.7;  // Significant penalty for very small networks
      } else if (totalCount >= 5 && totalCount < 10) {
        scalingMultiplier = 0.85; // Moderate penalty for small networks
      } else {
        scalingMultiplier = 1.0;  // Standard scoring for all other networks
      }
      
      score = score * scalingMultiplier;
      
      return Math.round(Math.min(score, 100));
    },
    getPowerRatingClass(rating) {
      if (rating >= 80) return 'excellent';  // Top influencers (80-100)
      if (rating >= 60) return 'good';       // Strong networkers (60-79) 
      if (rating >= 40) return 'moderate';   // Developing networks (40-59)
      return 'needs-attention';              // At risk (0-39)
    },
    getInnerPercentage(row) {
      if (row.total_count === 0) return 0;
      return Math.round((row.inner_count / row.total_count) * 100);
    },
    renderPowerRatingHeader(createElement, { column, $index }) {
      return (
        <el-tooltip content="Top center" placement="top" effect="light">
          <div slot="content" style="max-width: 320px; padding: 12px;">
            <div class="fw-700 fs-15 mb-6">Relationship Power Rating (0-100)</div>
            <div class="fs-12 mb-3 opa-08">
              Advanced formula based on organizational psychology and social network theory
            </div>
            <div class="fs-12 mb-3">
              <div class="fw-600 mb-2">Scoring Factors:</div>
              <div class="opa-08 fs-11" style="line-height: 1.5;">
                • <strong>Strong Connections (40%)</strong>: More is better with diminishing returns - sweet spot at 3-5<br/>
                • <strong>Network Position (30%)</strong>: Structural advantages from signatures (Hub, Influencer, Broker)<br/>
                • <strong>Connection Efficiency (15%)</strong>: Total reach with diminishing returns after 30<br/>
                • <strong>Network Diversity (10%)</strong>: Cross-functional reach + team integration (both matter)<br/>
                • <strong>Manager Support (5%)</strong>: Alignment with manager's network strength<br/>
                • <strong>Network Size Scaling</strong>: &lt;5 connections (×0.7), 5-9 (×0.85), 10+ (×1.0)
              </div>
            </div>
            {/* Combined Legend & Distribution */}
            <div class="fs-12 mt-10 pt-10" style="border-top: 1px solid #eee;">
              <div class="fw-600 mb-3">Team Distribution ({this.powerScoreDistribution.total} people)</div>
              
              <div class="combined-legend-chart">
                <div class="legend-chart-row">
                  <div class="legend-info">
                    <span class="color-indicator bg-green"></span>
                    <div class="legend-text">
                      <div class="fw-600 fs-11">80-100: Top Influencers</div>
                      <div class="fs-10 opa-06">Optimal connections + powerful position</div>
                    </div>
                  </div>
                  <div class="chart-section">
                    <div class="chart-bar-container">
                      <div class="chart-bar bg-green" style={`width: ${this.powerScoreDistribution.total > 0 ? Math.max((this.powerScoreDistribution.topInfluencers / this.powerScoreDistribution.total) * 100, 3) : 3}%;`}></div>
                    </div>
                    <div class="chart-value fs-11 fw-600">{this.powerScoreDistribution.topInfluencers}</div>
                  </div>
                </div>
                
                <div class="legend-chart-row">
                  <div class="legend-info">
                    <span class="color-indicator bg-blue"></span>
                    <div class="legend-text">
                      <div class="fw-600 fs-11">60-79: Strong Networkers</div>
                      <div class="fs-10 opa-06">Good quality + favorable position</div>
                    </div>
                  </div>
                  <div class="chart-section">
                    <div class="chart-bar-container">
                      <div class="chart-bar bg-blue" style={`width: ${this.powerScoreDistribution.total > 0 ? Math.max((this.powerScoreDistribution.strongNetworkers / this.powerScoreDistribution.total) * 100, 3) : 3}%;`}></div>
                    </div>
                    <div class="chart-value fs-11 fw-600">{this.powerScoreDistribution.strongNetworkers}</div>
                  </div>
                </div>
                
                <div class="legend-chart-row">
                  <div class="legend-info">
                    <span class="color-indicator bg-yellow"></span>
                    <div class="legend-text">
                      <div class="fw-600 fs-11">40-59: Developing Networks</div>
                      <div class="fs-10 opa-06">Building connections, emerging influence</div>
                    </div>
                  </div>
                  <div class="chart-section">
                    <div class="chart-bar-container">
                      <div class="chart-bar bg-yellow" style={`width: ${this.powerScoreDistribution.total > 0 ? Math.max((this.powerScoreDistribution.developing / this.powerScoreDistribution.total) * 100, 3) : 3}%;`}></div>
                    </div>
                    <div class="chart-value fs-11 fw-600">{this.powerScoreDistribution.developing}</div>
                  </div>
                </div>
                
                <div class="legend-chart-row">
                  <div class="legend-info">
                    <span class="color-indicator bg-red"></span>
                    <div class="legend-text">
                      <div class="fw-600 fs-11">0-39: At Risk</div>
                      <div class="fs-10 opa-06">Limited connections or isolated position</div>
                    </div>
                  </div>
                  <div class="chart-section">
                    <div class="chart-bar-container">
                      <div class="chart-bar bg-red" style={`width: ${this.powerScoreDistribution.total > 0 ? Math.max((this.powerScoreDistribution.atRisk / this.powerScoreDistribution.total) * 100, 3) : 3}%;`}></div>
                    </div>
                    <div class="chart-value fs-11 fw-600">{this.powerScoreDistribution.atRisk}</div>
                  </div>
                </div>
              </div>
              
              {/* Team Average */}
              <div class="team-average-summary">
                <span class="fs-12 fw-600 opa-08">Team Average:</span>
                <span class="average-score-balanced">{this.powerScoreDistribution.average}<span class="fs-11 opa-06">/100</span></span>
              </div>
            </div>
          </div>
          <span class="header-text-tooltip">Power</span>
        </el-tooltip>
      );
    },
    renderDistributionHeader(createElement, { column, $index }) {
      return (
        <el-tooltip content="Top center" placement="top" effect="light">
          <div slot="content" style="max-width: 240px; padding: 12px;">
            <div class="fw-700 fs-13 mb-2">Connection Distribution</div>
            <div class="fs-12 opa-08 mb-2">
              Distribution of connections within team (inner) vs across organization (outer). The dark blue bar shows the percentage of inner team connections.
            </div>
            <div class="fs-11 opa-06">
              Optimal balance: 40-60% inner connections for healthy cross-functional collaboration
            </div>
          </div>
          <span class="header-text-tooltip">Inner/Outer</span>
        </el-tooltip>
      );
    },
    renderTotalConnectionsHeader(creatElement, { column, $index }) {
      return (
        <el-tooltip content="Top center" placement="top" effect="light">
          <div slot="content" style="max-width: 220px; padding: 12px;">
            <div class="fw-700 fs-13 mb-2">Total Connections</div>
            <div class="fs-12 opa-08">
              Total number of meaningful connections formed through recognition, feedback, and interactions. Includes both inner team and outer organizational connections.
            </div>
          </div>
          <span class="header-text-tooltip">Total</span>
        </el-tooltip>
      );
    },
    renderInnerConnectionsHeader(creatElement, { column, $index }) {
      return (
        <div class="enhanced-header">
          <span class="header-text">Inner</span>
          <el-tooltip content="Top center" placement="top">
            <div slot="content" style="width: 220px">Connections within the same team or department. These represent close working relationships and frequent collaboration.</div>
            <i class="el-icon-info header-info-icon"></i>
          </el-tooltip>
        </div>
      );
    },
    renderOuterConnectionsHeader(creatElement, { column, $index }) {
      return (
        <div class="enhanced-header">
          <span class="header-text">Outer</span>
          <el-tooltip content="Top center" placement="top">
            <div slot="content" style="width: 220px">Connections outside the immediate team or department. These represent cross-functional relationships and broader organizational network.</div>
            <i class="el-icon-info header-info-icon"></i>
          </el-tooltip>
        </div>
      );
    },
    renderMERatioHeader(creatElement, { column, $index }) {
      return (
        <el-tooltip content="Top center" placement="top" effect="light">
          <div slot="content" style="max-width: 240px; padding: 12px;">
            <div class="fw-700 fs-13 mb-2">Manager/Employee Ratio</div>
            <div class="fs-12 opa-08">
              The ratio of the direct manager's and employee's total connections. A manager plays an important role of initiating connections for their team. Employees with low M/E ratios are more often disengaged due to a high difference in network value between them and their direct manager.
            </div>
          </div>
          <span class="header-text-tooltip">M/E Ratio</span>
        </el-tooltip>
      );
    },
    async showPreviewData(row) {
      try {
        // Ensure people store data is loaded for leaderboard information
        const allPeople = this.$store.getters["people/starperform"];
        if (!allPeople || allPeople.length === 0) {
          await this.$store.dispatch("people/getStarAndRiskPerform", this.user);
        }
        
        // Create basic profile immediately and open modal
        this.createBasicProfile(row);
        this.modalPreviewDataStatus = true;
        
        // Load complete data in background
        const completeUserData = await this.getCompleteUserData(row);
        
        if (completeUserData) {
          // Update with complete data once available
          this.createUserDetail(completeUserData, row);
          
          // Load additional data in parallel
          Promise.all([
            this.$store.dispatch("newmember/getDataHerepoint", row.email),
            this.$store.dispatch("people/getModalMemberData", completeUserData)
          ]);
        }
        
      } catch (error) {
        console.error('Error showing user preview:', error);
        // Provide user feedback for production
        this.$message({
          type: 'warning',
          message: 'Some profile data could not be loaded, but basic information is available.'
        });
      }
    },
    
    focusPersonInMap(row) {
      // Set the focused email in the store
      this.$store.commit("relationships/setSelectedEmail", row.email);
      
      // Prefer in-place update for focus to avoid reloads
      if (this.iframeLoaded) {
        this.sendIframeParamUpdate({ email: row.email });
      } else {
        this.scheduleIframeReload();
      }
    },
    
    clearFocusInMap() {
      // Clear the focused email
      this.$store.commit("relationships/setSelectedEmail", "");
      
      // Update iframe without reload if possible
      if (this.iframeLoaded) {
        this.sendIframeParamUpdate({ email: '' });
      } else {
        this.scheduleIframeReload();
      }
    },
    
    async getCompleteUserData(row) {
      // Strategy 1: Check people store (most complete data)
      const allPeople = this.$store.getters["people/starperform"];
      if (allPeople && allPeople.length > 0) {
        const userData = allPeople.find(person => person.email === row.email);
        if (userData) return userData;
      }
      
      // Strategy 2: Load people data if not available
      if (!allPeople || allPeople.length === 0) {
        await this.$store.dispatch("people/getStarAndRiskPerform", this.user);
        const refreshedPeople = this.$store.getters["people/starperform"];
        if (refreshedPeople) {
          const userData = refreshedPeople.find(person => person.email === row.email);
          if (userData) return userData;
        }
      }
      
      // Strategy 3: Check membersAll as fallback (less complete but available)
      const allMembers = this.membersAll;
      if (allMembers && Object.keys(allMembers).length > 0) {
        // Try multiple lookup strategies for reliability
        const lookupStrategies = [
          () => row.emailKey && allMembers[row.emailKey],
          () => allMembers[row.email],
          () => {
            const memberKey = Object.keys(allMembers).find(key => 
              allMembers[key] && allMembers[key].email === row.email
            );
            return memberKey ? allMembers[memberKey] : null;
          }
        ];
        
        for (const strategy of lookupStrategies) {
          const memberData = strategy();
          if (memberData) return memberData;
        }
      }
      
      return null;
    },
    
    createUserDetail(completeUserData, row) {
      // Clear previous data
      this.userDetail = {};
      
      // Core profile information
      this.userDetail.firstname = completeUserData.firstname || row.fullName.split(' ')[0] || '';
      this.userDetail.lastname = completeUserData.lastname || row.fullName.split(' ').slice(1).join(' ') || '';
      this.userDetail.email = row.email;
      this.userDetail.dispteam = completeUserData.team_name || row.teamName;
      
      const colorCode = (completeUserData.team_color || row.teamColor || '#6C30CC').replace(/#/g, "");
      this.userDetail.team_color = colorCode;
      this.userDetail.team = completeUserData.team || row.team;
      
      // Boss information
      this.userDetail.boss = completeUserData.boss || row.boss;
      this.userDetail.tmp_boss = this.userDetail.boss;
      this.userDetail.boss_pic = completeUserData.boss_pic || row.boss_pic;
      this.userDetail.dispboss = completeUserData.boss_name || row.boss_name;
      this.userDetail.boss_firstname = completeUserData.boss_firstname || row.boss_firstname;
      this.userDetail.boss_lastname = completeUserData.boss_lastname || row.boss_lastname;
      
      // User status and type
      this.userDetail.user_type = completeUserData.user_type || row.user_type;
      this.userDetail.status = completeUserData.status || row.status || 'active';
      this.userDetail.language = completeUserData.language;
      
      // Profile images with priority fallback
      this.userDetail.large_pic = completeUserData.large_pic || 
                                 completeUserData.profilepic_crop || 
                                 completeUserData.profilepic || 
                                 row.profileImage;
      this.userDetail.profilepic = completeUserData.profilepic || row.profileImage;
      this.userDetail.profilepic_crop = completeUserData.profilepic_crop;
      this.userDetail.profilepic_small = completeUserData.profilepic_small;
      
      // Achievement and engagement data with defaults
      this.userDetail.medal = completeUserData.medal || [];
      this.userDetail.coin = completeUserData.coin || 0;
      this.userDetail.gem = completeUserData.gem || 0;
      this.userDetail.streak_count = completeUserData.streak_count || 0;
      this.userDetail.super_feedback_count = completeUserData.super_feedback_count || 0;
      
      // House information with color mapping
      this.userDetail.house = completeUserData.house || row.house;
      this.userDetail.house_level = completeUserData.house_level;
      this.userDetail.house_color = completeUserData.house_color || this.mapHouseColor(this.userDetail.house);
      
      // Performance and talent data
      this.userDetail.talent = completeUserData.talent;
      this.userDetail.talent_value = completeUserData.talent_value;
      this.userDetail.impact_rating = completeUserData.impact_rating;
      this.userDetail.culture_add_percentile = completeUserData.culture_add_percentile;
      
      // Joining information
      this.userDetail.joined = completeUserData.joined || "";
      this.userDetail.joined_tooltips = (completeUserData.joined_tooltips && completeUserData.joined_tooltips.length > 0) 
        ? completeUserData.joined_tooltips[0] 
        : {};
      this.userDetail.order_join = completeUserData.order_join;
      this.userDetail.to_now = completeUserData.to_now;
      this.userDetail.introduce = completeUserData.introduce;
      
      // Calculate joining percentile if data available
      this.calculateJoiningPercentile();
      
      // Store relationship context
      this.userDetail.relationship_data = {
        total_connections: row.total_count,
        inner_connections: row.inner_count,
        outer_connections: row.outer_count,
        strong_connections: row.strong_count,
        me_ratio: row.me_ratio,
        signatures: row.signatures,
        power_rating: row.powerRating
      };
    },
    
    createBasicProfile(row) {
      // Try to get leaderboard data from people store if available
      const allPeople = this.$store.getters["people/starperform"];
      let peopleData = null;
      
      if (allPeople && allPeople.length > 0) {
        peopleData = allPeople.find(person => person.email === row.email);
      }
      
      // If no people data found, try membersAll store
      if (!peopleData && this.membersAll && Object.keys(this.membersAll).length > 0) {
        const emailKey = row.email.replace(/\./g, "||");
        peopleData = this.membersAll[emailKey];
      }
      
      // Create user detail with available data
      this.userDetail = {
        firstname: row.fullName.split(' ')[0] || '',
        lastname: row.fullName.split(' ').slice(1).join(' ') || '',
        email: row.email,
        dispteam: row.teamName,
        team_color: (row.teamColor || '#6C30CC').replace(/#/g, ""),
        team: row.team,
        boss: row.boss || '',
        tmp_boss: row.boss || '',
        boss_pic: row.boss_pic || '',
        dispboss: row.boss_name || '',
        user_type: row.user_type || 'user',
        status: row.status || 'active',
        large_pic: row.profileImage || '',
        profilepic: row.profileImage || '',
        house: (peopleData && peopleData.house) || row.house,
        house_color: this.mapHouseColor((peopleData && peopleData.house) || row.house),
        // Use actual leaderboard data if available, otherwise default to zero
        medal: (peopleData && peopleData.medal) || [],
        coin: (peopleData && peopleData.coin) || 0,
        gem: (peopleData && peopleData.gem) || 0,
        streak_count: (peopleData && peopleData.streak_count) || 0,
        super_feedback_count: (peopleData && peopleData.super_feedback_count) || 0,
        joined: (peopleData && peopleData.joined) || "",
        joined_tooltips: (peopleData && peopleData.joined_tooltips) || {},
        relationship_data: {
          total_connections: row.total_count,
          inner_connections: row.inner_count,
          outer_connections: row.outer_count,
          strong_connections: row.strong_count,
          me_ratio: row.me_ratio,
          signatures: row.signatures,
          power_rating: row.powerRating
        }
      };
    },
    
    mapHouseColor(houseId) {
      const houseColorMap = {
        '-LWOr-XsbZM2digYl1QL': '#1d97f2', // Delphinus (Blue)
        '-LWPrOElCYViBd6j6qP-': '#ffbf1f', // Leonos (Gold)
        '-LWPrZbcyHAVHIFUsWLd': '#ea183c'  // Corvus (Red)
      };
      return houseId ? houseColorMap[houseId] || '' : '';
    },
    
    calculateJoiningPercentile() {
      if (this.userDetail.order_join && this.membersAll && Object.keys(this.membersAll).length > 0) {
        const joinTotal = Object.keys(this.membersAll).filter(
          key => this.membersAll[key] && this.membersAll[key].order_join
        ).length;
        
        if (joinTotal > 0) {
          this.userDetail.joined_tooltips = this.userDetail.joined_tooltips || {};
          this.userDetail.joined_tooltips["percent"] = (
            ((joinTotal - this.userDetail.order_join) / joinTotal) * 100
          ).toFixed();
        }
      }
    },
    closedModal() {
      // Clean up modal data (matching people.vue pattern)
      this.$store.commit("people/setModalMemberData", []);
      this.modalPreviewDataStatus = false;
      this.userDetail = {};
    },
  },
  beforeDestroy() {
    // Clean up event listeners
    document.removeEventListener('keydown', this.handleEscKey);
    if (this.iframeSyncFrame) {
      cancelAnimationFrame(this.iframeSyncFrame);
    }
  },
};
</script>

<style lang="scss" scoped>
.iframe-container {
  width: 100%;
  max-height: 420px;
  border-radius: 24px;
  border: none;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.iframe-error-overlay,
.iframe-loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 24px;
  z-index: 10;
  
  .error-content {
    max-width: 300px;
    padding: 24px;
  }
}

.iframe-loading {
  background: #f8f9fa;
  color: #666;
}

.fullscreen-container {
  height: 100vh;
  width: 100vw;
  position: relative;
  overflow: hidden;
}

.fullscreen-iframe {
  max-height: none;
  height: 100%;
  border-radius: 0;
}

.relationships-fullscreen-dialog {
  margin: 0 !important;
  
  :deep(.el-dialog__body) {
    padding: 0;
    height: 100vh;
  }
}

.absolute-btn-iframe {
  position: absolute;
  bottom: 26px;
  right: 26px;
  cursor: pointer;
  background: #fff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  
  &:hover {
    transform: scale(1.1);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }
  
  img {
    width: 24px;
    height: 24px;
  }
}

.label-input {
  font-size: 14px;
  font-weight: 700;
  margin-right: 12px;
}
.menuOptionStyle {
  border-bottom: transparent;
  background: #f4f4f4;
  border-radius: 4px;
  margin-right: 16px;
}
.txtOption2 {
  color: #4a4a4a;
  font-size: 14px;
  margin-left: 16px;
  width: 154px;
  display: inline-block;
}

.table-heaer-category {
  margin-top: 24px;
  margin-bottom: 8px;
  .box {
    background-color: rgba($color: #6C30CC, $alpha: 0.04);
    border-radius: 4px;
    color: #454545;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    padding: 6px 12px;
  }
}

.value-line {
  font-size: 14px;
  font-weight: 500;
  text-decoration: underline;
  color: #000;
  cursor: pointer;
}
.value-no-line {
  font-size: 14px;
  font-weight: 500;
  color: #000;
}
.me-ratio {
  padding: 0 6px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 700;
  background: #ccc;
}
.me-ratio.green {
  background: rgba($color: #66bb6a, $alpha: 0.3);
  color: #28642a;
}
.me-ratio.yellow {
  background: rgba($color: #fbc02d, $alpha: 0.3);
  color: #745301;
}
.me-ratio.red {
  background: rgba($color: #f44336, $alpha: 0.3);
  color: #6e1d17;
}
.type-container {
  gap: 4px 7px;
  flex-direction: row;
  align-items: flex-start;
  flex-wrap: wrap;
}

.type-box-blue {
  box-shadow: 0px 2px 6px #00000029;
  border-radius: 4px;
  background-color: rgba($color: #236BDD, $alpha: 0.15);
  padding: 4px 8px 2px;
  margin-bottom: 6px;
  .icon {
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }
  .label {
    color: #2f0c67;
    font-size: 13px;
    font-weight: 500;
  }
}

.type-box-grey {
  box-shadow: 0px 2px 6px #00000029;
  border-radius: 4px;
  background-color: rgba($color: #9E9E9E, $alpha: 0.18);
  border-left: 3px solid #757575;
  padding: 4px 8px 2px;
  margin-bottom: 6px;
  .icon {
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }
  .label {
    color: #424242;
    font-size: 13px;
    font-weight: 500;
  }
}

.type-box {
  box-shadow: 0px 2px 6px #00000029;
  border-radius: 4px;
  background-color: rgba($color: #6c30cc, $alpha: 0.15);
  padding: 4px 8px 2px;
  margin-bottom: 6px;
  .icon {
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }
  .label {
    color: #2f0c67;
    font-size: 13px;
    font-weight: 500;
  }
}

// Signature-specific styling
.signature-badge-hub {
  background-color: rgba($color: #9c27b0, $alpha: 0.18) !important;
  border-left: 3px solid #9c27b0 !important;
  
  .label {
    color: #4a1152 !important;
  }
}

.signature-badge-influence {
  background-color: rgba($color: #673ab7, $alpha: 0.18) !important;
  border-left: 3px solid #673ab7 !important;
  
  .label {
    color: #311b92 !important;
  }
}

.signature-badge-connectivity {
  background-color: rgba($color: #3f51b5, $alpha: 0.18) !important;
  border-left: 3px solid #3f51b5 !important;
  
  .label {
    color: #1a237e !important;
  }
}

.signature-badge-collective {
  background-color: rgba($color: #2196f3, $alpha: 0.18) !important;
  border-left: 3px solid #2196f3 !important;
  
  .label {
    color: #0d47a1 !important;
  }
}

.signature-badge-brokerage {
  background-color: rgba($color: #009688, $alpha: 0.18) !important;
  border-left: 3px solid #009688 !important;
  
  .label {
    color: #004d40 !important;
  }
}

.signature-badge-strategist {
  background-color: rgba($color: #4caf50, $alpha: 0.18) !important;
  border-left: 3px solid #4caf50 !important;
  
  .label {
    color: #1b5e20 !important;
  }
}

.signature-badge-communityleader {
  background-color: rgba($color: #ff9800, $alpha: 0.18) !important;
  border-left: 3px solid #ff9800 !important;
  
  .label {
    color: #e65100 !important;
  }
}

.signature-badge-insularity {
  background-color: rgba($color: #795548, $alpha: 0.18) !important;
  border-left: 3px solid #795548 !important;
  
  .label {
    color: #3e2723 !important;
  }
}

.signature-badge-peripheral,
.signature-badge-distant {
  background-color: rgba($color: #9E9E9E, $alpha: 0.18) !important;
  border-left: 3px solid #757575 !important;
  
  .label {
    color: #424242 !important;
  }
}

.dropdownHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  padding-left: 24px;
  padding-right: 16px;
  margin-bottom: 10px;
  background: #f8f8f8;
  border-bottom: 1px solid #e8e8e8;
}

.dropdownHeaderTextStyle {
  font-size: 13px;
  font-weight: 700;
}

.el-button--text.dropdownHeaderTextStyle {
  color: #32c2d5;
}

.el-button--text.dropdownHeaderTextStyle:hover {
  color: #249fb0;
}

.el-button--text.dropdownHeaderTextStyle:active {
  color: #32c2d5;
}

.tooltipStyle {
  max-width: 240px;
}

.dropdownFooter {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 56px;
  padding-right: 16px;
  background: #f8f8f8;
  border-top: 1px solid #e8e8e8;

  .el-button--cancel {
    padding: 4px 16px;
    height: 24px;
    font-size: 13px;
    font-weight: 700;
    color: #747474;
    background-color: #e0e0e0;
    border-color: #e0e0e0;
  }

  .el-button--cancel:hover,
  .el-button--cancel:focus {
    color: #747474;
    background-color: #e0e0e0;
    border-color: #e0e0e0;
    opacity: 0.7;
  }

  .el-button--cancel:active {
    color: #747474;
    background-color: #e0e0e0;
    border-color: #e0e0e0;
    opacity: 1;
  }

  .el-button--save {
    padding: 4px 16px;
    height: 24px;
    font-size: 13px;
    font-weight: 700;
    color: #fff;
    background-color: #32c2d5;
    border-color: #32c2d5;
  }

  .el-button--save:hover,
  .el-button--save:focus {
    color: #fff;
    background-color: #32c2d5;
    border-color: #32c2d5;
    opacity: 0.7;
  }

  .el-button--save:active {
    color: #fff;
    background-color: #32c2d5;
    border-color: #32c2d5;
    opacity: 1;
  }
}

.el-dropdown-menu {
  width: 280px;
  padding-top: 0px;
  padding-bottom: 0px;
  border: 1px solid #e8e8e8;
}

.el-dropdown-menu__item {
  font-size: 13px;
  font-weight: 700;
  color: #292929;
  height: 24px;
  padding-bottom: 8px;
}

.el-dropdown-menu__item:hover,
.el-dropdown-menu__item:focus {
  cursor: default;
  background-color: initial !important;
}

.text-drop-down {
  color: #00acc1;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

/* Strong connections circular badge - consistent with power rating */
.strong-connections-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 6px 0;
}

.strong-connections-circle {
  font-size: 14px;
  font-weight: 700;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  color: white;
}

.strong-connections-circle.green {
  background: linear-gradient(135deg, #4CAF50, #66BB6A);
  box-shadow: 0 2px 6px rgba(76, 175, 80, 0.3);
}

.strong-connections-circle.yellow {
  background: linear-gradient(135deg, #FF9800, #FFB74D);
  box-shadow: 0 2px 6px rgba(255, 152, 0, 0.3);
}

.strong-connections-circle.red {
  background: linear-gradient(135deg, #F44336, #EF5350);
  box-shadow: 0 2px 6px rgba(244, 67, 54, 0.3);
}

.strong-connections-circle:hover {
  transform: translateY(-1px) scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

/* Minimal Strong Connections styles - matches M/E ratio design */
.strong-connections-cell-minimal {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px 0;
}

.strong-connections-badge {
  font-size: 14px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.strong-connections-badge.green {
  background: rgba(102, 187, 106, 0.3);
  color: #28642a;
}

.strong-connections-badge.yellow {
  background: rgba(251, 192, 45, 0.3);
  color: #745301;
}

.strong-connections-badge.red {
  background: rgba(244, 67, 54, 0.3);
  color: #6e1d17;
}

.strong-connections-badge:hover {
  transform: scale(1.05);
  opacity: 0.8;
}

/* Remove the old indicator styles that are no longer needed */
.strong-indicator,
.strong-indicator::after,
.strong-indicator.green::after,
.strong-indicator.yellow::after,
.strong-indicator.red::after {
  display: none;
}

.show-more-signatures {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  background-color: #f5f5f5;
  border-radius: 4px;
  color: #4a4a4a;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  margin-top: 2px;
  
  &:hover {
    background-color: #e8e8e8;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
  }
}

.signatures-popover-content {
  padding: 12px;
}

.signatures-popover-title {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 12px;
  color: #333;
  border-bottom: 1px solid #eee;
  padding-bottom: 8px;
}

.signatures-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  max-height: 400px;
  overflow-y: auto;
  padding-right: 8px;
}

.signature-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.signature-description {
  font-size: 12px;
  color: #666;
  line-height: 1.4;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
}

.no-signatures {
  color: #999;
  font-style: italic;
  font-size: 13px;
  padding: 4px 0;
}

/* Removed connection visualization styles - simplified to just values */

/* Simplified M/E Ratio styles */
.me-ratio-cell-simplified {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

/* Minimal M/E Ratio styles - removes visual prominence */
.me-ratio-cell-minimal {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px 0;
}

/* Fix profile image consistency */
.image-profile-42 {
  width: 42px !important;
  height: 42px !important;
  border-radius: 21px !important;
  flex-shrink: 0;
}

.text-in-image-42 {
  font-size: 15px !important;
  line-height: 42px !important;
  height: 42px !important;
  width: 42px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 !important;
  margin: 0 !important;
}

/* Split bar visualization for Inner/Outer distribution */
.distribution-split-bar {
  display: flex;
  width: 100%;
  height: 6px;
  border-radius: 3px;
  overflow: hidden;
  margin-bottom: 4px;
  background-color: #f0f0f0;
}

.distribution-inner-segment {
  background-color: #1565C0;
  transition: all 0.2s ease;
  cursor: help;
}

.distribution-outer-segment {
  background-color: #64B5F6;
  transition: all 0.2s ease;
  cursor: help;
}

.distribution-inner-segment:hover,
.distribution-outer-segment:hover {
  opacity: 0.8;
}

.me-ratio-badge {
  font-size: 14px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 12px;
}

.me-ratio-status {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.me-ratio-status.healthy {
  color: #2E7D32;
}

.me-ratio-status.moderate {
  color: #F57C00;
}

.me-ratio-status.concerning {
  color: #C62828;
}

.me-ratio-status.undefined {
  color: #757575;
}

/* Enhanced signature styles */
.signature-item-wrapper {
  display: inline-block;
}

/* Enhanced table header styles */
.enhanced-header {
  display: flex;
  align-items: center;
  gap: 6px;
}

.header-text {
  font-size: 12px;
  font-weight: 600;
  color: #333;
}

.header-text-tooltip {
  font-size: 12px;
  font-weight: 600;
  color: #333;
  cursor: pointer;
  transition: color 0.2s ease;
  border-bottom: 1px dotted transparent;
}

.header-text-tooltip:hover {
  color: #6C30CC;
  border-bottom-color: #6C30CC;
}

/* Tooltip styling to match app design */
.tooltip-legend-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 8px;
}

.tooltip-color {
  width: 12px;
  height: 12px;
  border-radius: 2px;
  flex-shrink: 0;
  margin-top: 2px;
}

.tooltip-color.bg-green {
  background: #4CAF50;
}

.tooltip-color.bg-blue {
  background: #2196F3;
}

.tooltip-color.bg-yellow {
  background: #FF9800;
}

.tooltip-color.bg-red {
  background: #F44336;
}

/* Enhanced hover states and visual polish */
.value-line {
  transition: color 0.2s ease;
}

.value-line:hover {
  color: #6C30CC;
}

/* Clickable names in relationship table */
.fs-14.fw-700.ellipsis.cursor-pointer:hover {
  color: #6C30CC;
  text-decoration: underline;
}

.strong-count:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.signature-item-wrapper {
  transition: transform 0.2s ease;
}

.signature-item-wrapper:hover {
  transform: translateY(-1px);
}

.type-container {
  gap: 6px 8px;
}

.connection-cell {
  min-height: 48px;
  justify-content: center;
}

.me-ratio-cell {
  min-height: 48px;
  justify-content: center;
}

/* Improved table row spacing */
.relationship-table .el-table tbody tr {
  transition: background-color 0.2s ease;
}

.relationship-table .el-table tbody tr:hover {
  background-color: rgba(108, 48, 204, 0.02) !important;
}

/* Power Rating styles */
.power-rating-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 6px 0;
}

.power-rating-score {
  font-size: 15px;
  font-weight: 700;
  width: 36px;
  height: 36px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.power-rating-score.excellent {
  background: linear-gradient(135deg, #4CAF50, #66BB6A);
  color: white;
  box-shadow: 0 2px 6px rgba(76, 175, 80, 0.3);
}

.power-rating-score.good {
  background: linear-gradient(135deg, #2196F3, #42A5F5);
  color: white;
  box-shadow: 0 2px 6px rgba(33, 150, 243, 0.3);
}

.power-rating-score.moderate {
  background: linear-gradient(135deg, #FF9800, #FFB74D);
  color: white;
  box-shadow: 0 2px 6px rgba(255, 152, 0, 0.3);
}

.power-rating-score.needs-attention {
  background: linear-gradient(135deg, #F44336, #EF5350);
  color: white;
  box-shadow: 0 2px 6px rgba(244, 67, 54, 0.3);
}

.power-rating-score:hover {
  transform: translateY(-1px) scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

/* Removed power rating bar styles - simplified to just circular badge */

/* Distribution column styles */
.distribution-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 6px 0;
}

.distribution-visual {
  width: 80%;
  max-width: 80px;
}

.distribution-bar {
  height: 8px;
  background: #E8F5E9;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  border: 1px solid #E0E0E0;
}

.distribution-inner {
  height: 100%;
  background: linear-gradient(90deg, #4CAF50, #66BB6A);
  border-radius: 3px 0 0 3px;
  transition: width 0.3s ease;
}

.distribution-values {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  font-weight: 500;
}

.inner-value {
  color: #1565C0;
}

.outer-value {
  color: #64B5F6;
}

.separator {
  color: #999;
  font-weight: 400;
}

.inner-value.clickable,
.outer-value.clickable {
  cursor: pointer;
  text-decoration: underline;
  transition: opacity 0.2s ease;
}

.inner-value.clickable:hover,
.outer-value.clickable:hover {
  opacity: 0.7;
}
</style>

<style lang="scss">
.relationship-table .el-table {
  .el-table__header-wrapper {
    padding-bottom: 6px;
  }
  th > .cell {
    font-size: 12px;
    color: #000;
    // margin-bottom: 6px;
  }
  .is-leaf {
    padding-top: 0;
    padding-bottom: 0;
    border-bottom: 1px solid #e0e0e0 !important;
  }
  td.el-table__cell {
    padding: 6px 0 6px;
  }
}

.dropdownItem-tabActivity {
  overflow-y: auto;
  max-height: 228px;
  margin-right: 12px;

  .el-checkbox__input + .el-checkbox__label {
    font-weight: 700;
  }

  .el-checkbox__input.is-checked + .el-checkbox__label {
    font-weight: 700;
    color: #292929;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #00bcd4;
    border-color: #00bcd4;
  }
}

.relationships-fullscreen-dialog {
  .el-dialog {
    margin: 0 !important;
    width: 100% !important;
    height: 100% !important;
    max-width: none !important;
    border-radius: 0;
  }
  
  .el-dialog__body {
    padding: 0;
    height: 100vh;
  }
}

.signatures-popover {
  max-width: 320px;
  
  .el-popover__title {
    font-size: 16px;
    font-weight: 700;
    color: #333;
  }
}

/* Combined Legend & Distribution Chart Styles */
.combined-legend-chart {
  margin: 12px 0;
}

.legend-chart-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  gap: 12px;
}

.legend-info {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 180px;
  flex-shrink: 0;
}

.legend-text {
  line-height: 1.3;
}

.color-indicator {
  width: 12px;
  height: 12px;
  border-radius: 2px;
  flex-shrink: 0;
  margin-top: 1px;
  
  &.bg-green {
    background-color: #3AC47D;
  }
  
  &.bg-blue {
    background-color: #1976d2;
  }
  
  &.bg-yellow {
    background-color: #F7B924;
  }
  
  &.bg-red {
    background-color: #CC3030;
  }
}

.chart-section {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}

.chart-bar-container {
  flex: 1;
  height: 14px;
  background-color: #f5f5f5;
  border-radius: 7px;
  overflow: hidden;
  position: relative;
}

.chart-bar {
  height: 100%;
  border-radius: 7px;
  transition: width 0.4s ease;
  min-width: 3px;
  
  &.bg-green {
    background: linear-gradient(90deg, #3AC47D 0%, #2EA968 100%);
  }
  
  &.bg-blue {
    background: linear-gradient(90deg, #1976d2 0%, #1565c0 100%);
  }
  
  &.bg-yellow {
    background: linear-gradient(90deg, #F7B924 0%, #f9a825 100%);
  }
  
  &.bg-red {
    background: linear-gradient(90deg, #CC3030 0%, #b71c1c 100%);
  }
}

.chart-value {
  width: 30px;
  text-align: right;
  flex-shrink: 0;
  color: #333;
}

/* Balanced Team Average Styles */
.team-average-summary {
  margin-top: 12px;
  padding: 8px 12px;
  background-color: #f8f9fa;
  border-radius: 6px;
  border-left: 3px solid #6C30CC;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.average-score-balanced {
  font-size: 16px;
  font-weight: 700;
  color: #6C30CC;
}

/* Power Filter Indicator Styles */
.power-indicator {
  width: 10px;
  height: 10px;
  border-radius: 2px;
  margin-right: 6px;
  
  &.bg-green {
    background-color: #3AC47D;
  }
  
  &.bg-blue {
    background-color: #1976d2;
  }
  
  &.bg-yellow {
    background-color: #F7B924;
  }
  
  &.bg-red {
    background-color: #CC3030;
  }
}

/* Inline focus icon styles */
.name-with-focus {
  position: relative;
}

.focus-icon-inline {
  margin-left: 4px;
  color: #909399;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  opacity: 0.8;
  position: relative;
  top: -1px; /* Slight vertical alignment adjustment */
}

.focus-icon-inline:hover {
  color: #6c30cc;
  opacity: 1;
  transform: scale(1.1);
}

/* Ensure the icon doesn't cause text overflow */
.name-with-focus {
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
}

/* Focus tag styling */
.focus-tag {
  font-size: 12px;
  background-color: #f0f9ff;
  border-color: #0ea5e9;
  color: #0369a1;
}
</style>
